var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgUsAnnotated(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 1000,
    viewBox: "0 0 897.2013 529.09125",
    style: {
      fill: "none",
      stroke: "#000000",
      strokeLinejoin: "round"
    },
    pretty_print: "False",
    enable_background: "new 0 0 1000 589",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    y: 154.02431,
    x: 832.76636,
    height: 27.196415,
    width: 38.32222,
    id: "rect790-37-2",
    style: {
      fill: "#cccccc",
      stroke: "none",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    y: 193.40408,
    x: 804.84161,
    height: 27.196415,
    width: 38.32222,
    id: "rect790-37-7",
    style: {
      fill: "#cccccc",
      stroke: "none",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    y: 233.27156,
    x: 802.06018,
    height: 27.196415,
    width: 38.32222,
    id: "rect790-37-6",
    style: {
      fill: "#cccccc",
      stroke: "none",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    y: 261.70419,
    x: 785.06244,
    height: 27.196415,
    width: 38.32222,
    id: "rect790-37-5",
    style: {
      fill: "#cccccc",
      stroke: "none",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    y: 436.86243,
    x: 223.05104,
    height: 27.196415,
    width: 38.32222,
    id: "rect790-37-60",
    style: {
      fill: "#cccccc",
      stroke: "none",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    y: 119.10164,
    x: 840.8017,
    height: 27.196415,
    width: 38.32222,
    id: "rect790-37-9",
    style: {
      fill: "#cccccc",
      stroke: "none",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    y: 80.462173,
    x: 855.75989,
    height: 27.196415,
    width: 38.32222,
    id: "rect790-37",
    style: {
      fill: "#cccccc",
      stroke: "none",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    y: 48.797157,
    x: 858.87909,
    height: 27.196415,
    width: 38.32222,
    id: "rect790-0",
    style: {
      fill: "#cccccc",
      stroke: "none",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    y: 9.6649303,
    x: 725.88812,
    height: 27.196415,
    width: 38.32222,
    id: "rect790-3",
    style: {
      fill: "#cccccc",
      stroke: "none",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    y: 34.861347,
    x: 689.56592,
    height: 27.196415,
    width: 38.32222,
    id: "rect790",
    style: {
      fill: "#cccccc",
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#68c95e",
      fillRule: "evenodd",
      strokeWidth: 0.97063118
    },
    d: "m 806.49746,131.71469 -0.29118,-0.19412 v 0.29119 l 0.29118,-0.0971 z m -2.91189,-2.6207 0.67944,-0.29119 v -0.38825 z m 12.03583,-7.57092 -0.0971,-1.35889 -0.19412,-0.7765 0.29119,2.13539 z m -42.41659,-9.9975 -0.67944,0.29119 -5.5326,1.65007 -1.94126,0.67944 -2.23245,0.67944 -0.7765,0.29119 v 0.29119 l 0.29118,5.04728 0.29119,4.65903 0.29119,4.27078 0.48532,0.29119 1.74714,-0.48532 7.86211,-2.32951 0.19412,0.48531 13.97709,-5.33847 0.0971,0.19413 1.26182,-0.48532 4.4649,-1.74713 4.27078,5.14434 v 0 l 0.58238,-0.48531 0.29119,-1.45595 -0.0971,2.32952 v 0 h 0.97063 l 0.29119,1.16475 0.87357,1.65008 v 0 l 4.56197,-5.5326 3.78546,1.26182 0.87357,-1.94126 6.21204,-3.30015 -2.62071,-5.14435 0.67945,3.30015 -3.20309,2.42658 -3.59133,0.29119 -7.18267,-7.66799 -3.20309,-4.85315 3.20309,-3.39721 -3.30015,-0.19413 -1.35888,-3.20308 -0.0971,-0.19413 -5.53259,6.01791 -12.22996,4.07666 -3.97959,1.26182 v 0 z",
    "data-id": "MA",
    "data-name": "Massachusetts",
    id: "MA"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#68c95e",
      fillRule: "evenodd",
      strokeWidth: 0.97063118
    },
    d: "m 408.7328,52.511184 1.94126,6.891482 4.07665,24.848159 1.94126,9.90044 0.58238,8.735685 2.23246,5.24141 0.48531,4.4649 0.38825,1.45595 -0.0971,0.29119 -3.88252,6.40616 2.52364,4.27078 4.85315,34.16622 0.19413,4.4649 4.85315,-0.29119 19.12144,-1.06769 47.75505,-3.97959 4.7561,-0.48532 v -0.48531 l -1.35889,-7.47386 -5.92085,-3.00896 -4.65903,-4.85315 -7.37679,-4.46491 -2.32952,-0.19412 -3.59133,-2.71777 0.97063,-13.39471 -3.39721,-3.10602 1.16476,-5.43554 6.21204,-5.62966 -1.0677,-11.647575 2.23245,-2.52364 v 0 l 7.57093,-7.95918 8.63861,-11.065195 3.30015,-2.329514 5.82379,-2.814831 6.11497,-4.561967 -4.07665,0.776505 -2.42658,-1.844199 -9.31806,1.261821 -1.45594,-1.747136 -8.34743,3.397209 -6.69736,-2.814831 -1.84419,-2.232452 -5.33848,0.388253 -3.59133,-1.844199 1.16476,-1.358884 -4.56197,-1.455947 h -4.07665 l -6.50323,2.814831 -1.26182,-1.941263 -10.28869,-1.455947 -3.49427,-8.73568 -0.38826,-2.620705 -4.4649,-1.26182 0.38825,7.47386 -11.8417,0.873568 -14.65653,0.582379 -0.97063,0.09706 z",
    "data-id": "MN",
    "data-name": "Minnesota",
    id: "MN"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#c6c627",
      fillRule: "evenodd",
      strokeWidth: 0.97063118
    },
    d: "M 315.84339,51.637616 283.7155,49.502227 260.32329,47.269776 237.02814,44.552008 222.56573,42.610746 199.46471,39.01941 187.9142,37.078148 l -25.81879,-4.950219 -2.71777,-0.582379 -4.17371,19.800877 1.8442,3.591335 1.45595,5.532598 -0.87357,0.776505 1.8442,5.047282 2.52364,2.135389 7.18267,12.035829 0.67944,2.03832 2.91189,-0.19412 -3.39721,15.91835 -1.35888,0.38825 -1.8442,5.338475 9.60925,0.67944 0.77651,4.46491 5.43553,13.29765 0.97063,0.7765 3.78546,7.76505 0.97063,-0.7765 8.05624,-0.0971 10.19163,1.0677 2.52364,-3.30015 3.00896,5.43553 0.58238,0.29119 0.0971,-0.58237 1.35888,-9.51219 33.19559,4.07665 26.49823,2.52364 13.97709,1.16476 24.94522,1.45595 1.26182,0.0971 h 0.29119 l 0.0971,-1.35888 0.29119,-6.69736 0.38825,-8.83274 0.0971,-2.23246 0.19413,-3.88252 1.55301,-30.477825 1.26182,-23.683401 0.0971,-3.882525 -1.8442,-0.09706 z",
    "data-id": "MT",
    "data-name": "Montana",
    id: "MT"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#cb1d1d",
      fillRule: "evenodd",
      strokeWidth: 0.97063118
    },
    d: "m 406.69447,52.511184 -29.31306,0.582379 -20.48032,-0.09706 -17.56842,-0.388253 -20.57738,-0.776505 -1.0677,-0.09706 -0.0971,3.882525 -1.26182,23.683405 -1.55301,30.477825 -0.19413,3.88252 3.78546,0.19413 42.80484,1.16476 39.50469,-0.29119 16.40367,-0.48532 3.30014,-0.19412 -0.38825,-1.45595 -0.48531,-4.4649 -2.23246,-5.24141 -0.58238,-8.735685 -1.94126,-9.90044 -4.07665,-24.848163 -1.94126,-6.891482 h -2.03833 z",
    "data-id": "ND",
    "data-name": "North Dakota",
    id: "ND"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#c6c627",
      fillRule: "evenodd",
      strokeWidth: 0.97063118
    },
    d: "m 266.53533,493.66307 -3.00896,-2.23245 -2.6207,0.67944 0.58238,5.43553 -3.59134,4.46491 3.10602,7.08561 0.87357,7.27973 3.59133,2.32951 2.23246,-3.59133 3.97958,-2.91189 4.85316,-1.26183 5.33847,-4.56196 -5.24141,-4.46491 -0.0971,-2.71776 -9.9975,-5.5326 z m -17.66549,-7.86211 -1.45595,-1.26182 -1.35888,1.8442 z m -7.27973,-4.17372 0.38825,-3.59133 -1.8442,-0.29119 z m 6.11497,-5.92085 -1.65007,0.77651 1.16476,3.6884 2.52364,0.19412 0.7765,3.20308 2.71777,1.16476 6.01791,-2.81483 -5.62966,-4.65903 z m -12.42408,-3.97959 -0.87356,2.62071 4.17371,-0.0971 3.88252,0.97063 -2.03832,-3.20309 -5.14435,-0.29119 z m -12.22995,-7.66798 -2.23245,-2.13539 -4.27078,3.30015 2.71777,5.04728 1.94126,-2.03833 5.5326,1.16476 -0.48532,-2.32952 z m -43.48428,-4.27078 0.58238,-1.35888 1.65007,-0.87357 z m 15.43304,-8.83274 -6.79442,2.52364 -0.67944,1.8442 2.71777,1.94126 3.78546,0.97063 2.71776,-5.33847 z M 147.9242,433.09568 v -0.0971 h -0.19413 z M 96.480735,420.38041 v 0.19413 h 0.0971 z m -26.98355,-4.4649 0.0971,0.0971 v 0 z m -1.94126,-2.91189 h -0.19412 v 0.0971 z m 0.67944,0 h -0.0971 z m -0.0971,-0.0971 v 0 0.0971 z m -30.47782,-25.04228 -0.0971,-0.29119 v 0.0971 l 0.0971,0.19413 z",
    "data-id": "HI",
    "data-name": "Hawaii",
    id: "HI"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#cb1d1d",
      fillRule: "evenodd",
      strokeWidth: 0.97063118
    },
    d: "m 159.28058,31.54555 -8.63862,-1.747136 -2.81483,-0.679442 -1.26182,-0.291189 -11.25932,50.666952 0.48532,4.17371 -0.38826,4.36784 0.19413,0.97063 v 0.0971 l 0.0971,1.84419 3.30015,3.59134 -4.75609,11.938765 -10.09457,13.20059 -0.29119,2.42658 2.62071,6.21204 -9.221,38.24287 -0.38825,2.03832 2.71776,0.58238 27.46887,5.43553 10.96813,2.03833 2.81483,0.48532 2.71777,0.48531 13.97709,2.23245 25.04228,3.78546 2.81483,0.38826 0.38825,-3.20309 0.87357,-6.3091 3.30015,-25.23641 1.74714,-12.52114 0.38825,-3.20309 -0.58238,-0.29119 -3.00896,-5.43553 -2.52364,3.30015 -10.19163,-1.0677 -8.05624,0.0971 -0.97063,0.7765 -3.78546,-7.76505 -0.97063,-0.7765 -5.43553,-13.29765 -0.77651,-4.46491 -9.60925,-0.67944 1.8442,-5.338475 1.35888,-0.38825 3.39721,-15.91835 -2.91189,0.19412 -0.67944,-2.03832 -7.18267,-12.035829 -2.52364,-2.135389 -1.8442,-5.047282 0.87357,-0.776505 -1.45595,-5.532598 -1.8442,-3.591335 4.17371,-19.800877 h -0.0971 z",
    "data-id": "ID",
    "data-name": "Idaho",
    id: "ID"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#68c95e",
      fillRule: "evenodd",
      strokeWidth: 0.97063118
    },
    d: "m 42.319515,55.714267 0.0971,-1.650073 -0.19412,0.09706 0.0971,1.55301 z m 20.67445,-8.832744 0.58237,-0.970631 -0.67944,-0.09706 0.0971,1.067694 z m -1.8442,-1.747136 0.58237,-1.941262 -0.58237,-0.194127 z m 7.0856,-2.814831 -0.0971,-1.941262 -1.65007,2.523641 1.74713,-0.582379 z m 0.19413,-4.076651 0.29119,-1.941262 -0.19413,-0.485316 -0.0971,2.426578 z m 0.29119,-9.512185 -0.0971,-1.067695 -0.38826,-0.09706 0.48532,1.164758 z m 3.10602,-6.406166 -0.87357,-0.09706 -1.74713,2.717767 2.6207,-2.620704 z m -2.42658,-2.620705 0.48532,-0.388252 0.0971,-0.291189 -0.58238,0.679441 z m -0.48531,0.29119 -0.29119,-1.941263 -0.87357,1.650073 z m -0.48532,-2.717768 -0.87357,-0.388252 0.67944,0.970631 z m 2.91189,1.650074 v -1.261821 l -0.29119,0.485316 z m 0.87357,-1.261821 -0.38825,-0.291189 h -0.0971 l 0.48531,0.291189 z m -5.5326,-2.135389 -0.48531,-0.388252 -0.19413,-0.09706 0.67944,0.485315 z m 3.59134,-0.388252 -2.6207,0.679442 0.67944,0.194126 z m -2.13539,-0.194126 -0.48531,-0.582379 -0.0971,0.09706 0.58238,0.485316 z m 2.03833,-1.164758 h -0.38826 l 0.48532,0.194126 -0.0971,-0.194126 z m -19.02438,49.793381 3.49428,3.785461 -0.58238,7.279734 0.67944,1.8442 5.24141,2.81483 14.75359,1.35888 0.58238,1.74714 6.98855,0.0971 6.60029,0.87357 10.774,-1.16476 5.338485,0.87357 1.45594,-0.67944 27.27474,6.21204 1.8442,0.38825 -0.19413,-0.97063 0.38826,-4.36784 -0.48532,-4.17371 11.25932,-50.666952 -1.55301,-0.29119 -22.71277,-5.338471 -19.80087,-5.047282 -22.421595,-6.21204 -6.69735,-1.650073 1.55301,8.444491 -1.45595,2.717768 -2.6207,-1.358884 2.52364,11.744637 -2.71777,3.882525 -1.26182,3.591336 v 3.688398 l -5.72672,3.979588 -2.42658,-1.55301 -2.32952,1.164758 4.27078,-5.532598 -1.06769,3.785462 2.42658,-2.620705 1.94126,0.388253 -0.58238,-4.853156 1.26182,0.194126 2.6207,-5.823787 -0.87356,-0.873568 -3.39721,4.36784 -2.23246,0.09706 2.42658,-2.717767 2.71777,-0.679442 -0.97063,-4.950219 -2.71777,-0.679442 -1.35888,-2.329515 -1.65008,0.873568 -8.9298,-3.882524 -7.86211,-6.114977 -2.13539,5.92085 -0.19413,2.523641 1.65007,4.464904 -1.06769,14.462405 -0.77651,2.232452 4.36784,0.388252 -4.36784,3.10602 2.32952,1.164757 -1.8442,6.21204 -0.87357,-4.853156 -1.65007,5.629661 2.23245,2.717767 2.42658,-0.194126 2.91189,1.747136 1.45595,2.814831 h 1.74713 v 0 z",
    "data-id": "WA",
    "data-name": "Washington",
    id: "WA"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#cb1d1d",
      fillRule: "evenodd",
      strokeWidth: 0.97063118
    },
    d: "m 222.37161,288.5687 -32.71027,-4.07665 -17.56843,-2.52365 -25.04228,-3.97958 -2.52364,-0.38826 v 0.19413 l -4.27078,18.83025 -2.23245,-0.0971 -3.39721,-3.00895 -4.27078,3.59133 -0.0971,15.43304 -1.55301,3.30014 v 0.29119 0.0971 l -0.19413,2.42657 3.39721,9.12394 3.00896,4.07665 -5.43554,3.20308 -2.13539,3.97959 -3.49427,8.54155 -1.74713,0.38826 -0.0971,7.0856 3.00896,2.23246 -1.55301,4.27077 -3.49427,0.19413 v 0 l -2.03833,3.78546 6.98855,4.36784 13.20058,7.3768 40.76651,21.64507 34.55447,4.27078 h 0.38825 l 2.71777,-28.63362 0.67944,-7.08561 7.27974,-75.12685 0.38825,-3.49427 -2.52364,-0.29119 z",
    "data-id": "AZ",
    "data-name": "Arizona",
    id: "AZ"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#c6c627",
      fillRule: "evenodd",
      strokeWidth: 0.97063118
    },
    d: "m 56.199545,342.43873 0.38825,2.13539 v 0.38825 z m -14.26828,-8.34743 0.67944,1.45595 0.38825,-0.0971 -1.06769,-1.35888 z m 16.98604,-0.29119 0.29119,2.52364 1.74714,1.26182 z m -11.74463,-13.78296 -1.0677,-0.29119 0.87357,0.38825 0.19413,-0.0971 z m -10.77401,-2.9119 -2.6207,1.55301 0.67944,0.67945 z m -5.04728,-1.8442 -0.19413,0.77651 0.87357,0.19413 z m 8.54155,1.94127 4.27078,2.42658 0.77651,-0.67945 z m -33.09852,-85.51261 -0.0971,0.0971 z m 10.38575,0.48531 -0.0971,-0.29119 v 0.38826 l 0.0971,-0.0971 z m 56.00542,-73.6709 -3.78546,-0.97064 -41.54301,-11.45344 -15.43304,-4.65903 v 0.38825 l -0.87357,9.60925 -4.07665,11.35638 -6.79441999,8.44449 -0.19412,4.27078 3.30013999,5.92085 1.65008,7.76505 -2.32952,6.3091 0.38825,6.30911 -1.16475,2.6207 3.97958,8.63862 2.52364,3.30015 -0.19412,9.41512 6.01791,5.72672 3.49427,-5.82378 3.78547,3.00895 1.45594,-1.35888 -5.24141,0.97063 -0.0971,4.95022 1.0677,6.21204 -2.9119,-2.81483 -1.65007,-3.78546 -0.48532,5.2414 1.35889,10.38576 5.43553,6.69735 -3.59133,4.65903 0.58237,5.92085 3.88253,6.01792 6.79442,18.63612 2.13539,1.16475 -0.67945,12.9094 1.0677,1.55301 14.55947,5.24141 4.4649,4.75609 1.55301,3.10602 4.27078,2.42658 4.65903,0.87357 1.94126,5.33847 3.88252,1.8442 5.82379,6.89148 5.43554,9.02687 -0.38826,8.34743 3.00896,3.97958 39.698825,3.88253 v 0 l 3.49427,-0.19413 1.55301,-4.27077 -3.00896,-2.23246 0.0971,-7.0856 1.74713,-0.38826 3.49427,-8.54155 2.13539,-3.97959 5.43554,-3.20308 -3.00896,-4.07665 -3.39721,-9.12394 0.19413,-2.42657 v -0.0971 l -2.52364,-3.39721 -7.76505,-10.38575 -15.04479,-21.15976 -20.965635,-30.08957 -11.8417,-16.40366 -11.45345,-16.50074 13.20058,-56.00542 0.87357,-3.68839 z",
    "data-id": "CA",
    "data-name": "California",
    id: "CA"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#68c95e",
      fillRule: "evenodd",
      strokeWidth: 0.97063118
    },
    d: "m 339.81798,234.21335 0.38826,-19.02437 -4.65903,-0.19413 -23.6834,-0.87357 -2.32952,-0.0971 -1.94126,-0.0971 -28.82775,-1.8442 -19.2185,-1.55301 -23.97459,-2.32952 -2.32951,-0.29119 -0.29119,2.52365 -5.24141,50.56988 -1.8442,17.66549 -0.7765,7.66799 -0.19413,2.52364 3.00896,0.29119 48.91981,4.27077 21.54801,1.35889 21.45095,0.97063 3.10602,0.0971 1.94126,0.0971 4.07665,0.0971 1.94127,0.0971 6.11497,0.19413 h 1.55301 v -1.94127 l 1.0677,-51.34639 0.0971,-5.72672 v -1.8442 l 0.0971,-1.26182 z",
    "data-id": "CO",
    "data-name": "Colorado",
    id: "CO"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#c6c627",
      fillRule: "evenodd",
      strokeWidth: 0.97063118
    },
    d: "m 145.0123,274.49454 10.09457,-62.79983 5.14434,-31.44846 0.58238,-3.10601 -2.81483,-0.48532 -10.96813,-2.03833 -27.46887,-5.43553 -2.71776,-0.58238 -2.71777,-0.58238 -13.6859,-3.00895 -24.556975,-5.82379 -2.71777,-0.67944 -0.87357,3.68839 -13.20058,56.00542 11.45345,16.50074 11.8417,16.40366 20.965635,30.08957 15.04479,21.15976 7.76505,10.38575 2.52364,3.39721 v -0.29119 l 1.55301,-3.30014 0.0971,-15.43304 4.27078,-3.59133 3.39721,3.00895 2.23245,0.0971 4.27078,-18.83025 v -0.19413 l 0.48531,-3.10602 z",
    "data-id": "NV",
    "data-name": "Nevada",
    id: "NV"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#cb1d1d",
      fillRule: "evenodd",
      strokeWidth: 0.97063118
    },
    d: "m 322.63781,303.41935 0.0971,-2.52364 0.0971,-2.52364 0.0971,-2.52364 -3.10602,-0.0971 -21.45095,-0.97063 -21.54801,-1.35889 -48.91981,-4.27077 -3.00896,-0.29119 -0.38825,3.49427 -7.27974,75.12685 -0.67944,7.08561 -2.71777,28.63362 0.38826,0.0971 13.39471,1.26183 1.26182,-6.79442 2.42658,-1.94127 27.17767,2.42658 h 0.19413 l -2.42658,-4.75609 12.32701,0.87357 30.76901,1.74713 19.2185,0.87357 3.30015,-91.0452 0.67944,0.0971 0.0971,-2.62071 z",
    "data-id": "NM",
    "data-name": "New Mexico",
    id: "NM"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#cb1d1d",
      fillRule: "evenodd",
      strokeWidth: 0.97063118
    },
    d: "m 12.424075,141.42101 15.43304,4.65903 41.54301,11.45344 3.78546,0.97064 2.71777,0.67944 24.556975,5.82379 13.6859,3.00895 2.71777,0.58238 0.38825,-2.03832 9.221,-38.24287 -2.62071,-6.21204 0.29119,-2.42658 10.09457,-13.20059 4.75609,-11.938765 -3.30015,-3.59134 -0.0971,-1.84419 v -0.0971 l -1.8442,-0.38825 -27.27474,-6.21204 -1.45594,0.67944 -5.338485,-0.87357 -10.774,1.16476 -6.60029,-0.87357 -6.98855,-0.0971 -0.58238,-1.74714 -14.75359,-1.35888 -5.24141,-2.81483 -0.67944,-1.8442 0.58238,-7.279734 -3.49428,-3.785461 -0.29118,0.09706 -0.67945,0.485315 -4.85315,-2.523641 -2.9119,0.873568 -1.94126,-0.970631 -2.03832,8.347429 -1.35889,2.329514 -6.01791,14.656531 -1.74714,8.05624 -1.06769,0.0971 -5.62966,13.394715 -3.78546,5.72672 -1.35889,0.97063 -3.49427,6.79442 -0.67944,7.18267 -2.13539,6.40617 1.26182,5.82378 v 0.0971 z m 35.5251,-79.68883 -0.29119,-0.873568 -0.0971,0.679442 0.38825,0.194126 z",
    "data-id": "OR",
    "data-name": "Oregon",
    id: "OR"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#68c95e",
      fillRule: "evenodd",
      strokeWidth: 0.97063118
    },
    d: "m 202.57073,183.64346 -25.04228,-3.78546 -13.97709,-2.23245 -2.71777,-0.48531 -0.58238,3.10601 -5.14434,31.44846 -10.09457,62.79983 -0.48531,3.10602 2.52364,0.38826 25.04228,3.97958 17.56843,2.52365 32.71027,4.07665 2.52364,0.29119 0.19413,-2.52364 0.7765,-7.66799 1.8442,-17.66549 5.24141,-50.56988 0.29119,-2.52365 -1.94126,-0.19412 -24.7511,-3.00896 -3.78546,-0.48531 2.42658,-18.92731 0.19412,-1.26182 z",
    "data-id": "UT",
    "data-name": "Utah",
    id: "UT"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#68c95e",
      fillRule: "evenodd",
      strokeWidth: 0.97063118
    },
    d: "m 311.57262,170.83113 0.7765,-15.14184 0.97063,-20.38326 0.0971,-2.52364 -1.26182,-0.0971 -24.94522,-1.45595 -13.97709,-1.16476 -26.49823,-2.52364 -33.19559,-4.07665 -1.35888,9.51219 -0.0971,0.58237 -0.38825,3.20309 -1.74714,12.52114 -3.30015,25.23641 -0.87357,6.3091 -0.38825,3.20309 -0.19412,1.26182 -2.42658,18.92731 3.78546,0.48531 24.7511,3.00896 1.94126,0.19412 2.32951,0.29119 23.97459,2.32952 19.2185,1.55301 28.82775,1.8442 1.94126,0.0971 0.0971,-2.52364 0.48532,-10.19163 0.87357,-17.76255 0.38825,-7.57092 0.0971,-2.52364 0.0971,-2.62071 z",
    "data-id": "WY",
    "data-name": "Wyoming",
    id: "WY"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#c6c627",
      fillRule: "evenodd",
      strokeWidth: 0.97063118
    },
    d: "m 540.64158,306.7195 -10.48282,1.55301 4.27078,-6.79442 -1.8442,-3.78546 -36.98105,3.59134 -31.25432,2.52364 -4.56197,0.29119 0.58238,2.71776 3.78546,19.60675 0.0971,4.36784 1.0677,26.40117 0.0971,4.36784 0.29119,0.0971 1.45595,1.55301 5.82378,-0.19413 0.58238,8.54155 0.19413,2.42658 3.00896,-0.29119 9.22099,-0.67944 36.5928,-3.39721 h 0.19412 l -0.0971,-2.13539 0.97063,-0.67944 -1.74713,-3.30014 3.6884,-15.5301 -1.45595,-1.74714 5.5326,-6.11498 -0.38826,-5.2414 4.07665,-6.79442 v -0.0971 l -0.19412,-0.19412 3.49427,-3.20309 -0.97063,-3.88252 2.71777,-4.27078 -0.58238,-3.97959 2.91189,-5.62966 v -0.0971 h -0.0971 z",
    "data-id": "AR",
    "data-name": "Arkansas",
    id: "AR"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#cb1d1d",
      fillRule: "evenodd",
      strokeWidth: 0.97063118
    },
    d: "m 511.71677,176.36373 -5.33847,-2.81483 -2.9119,-3.97959 -0.97063,-5.72672 0.77651,-2.62071 -2.81483,-3.39721 v 0 l -4.7561,0.48532 -47.75505,3.97959 -19.12144,1.06769 -4.85315,0.29119 -2.03833,0.0971 1.65008,10.77401 -1.35889,5.14435 2.13539,3.20308 v 0.67944 l 0.67944,0.0971 3.10602,9.12394 3.00896,4.75609 0.19413,5.43554 3.30014,4.56196 -0.58238,1.94126 3.00896,12.22996 v 0.29119 0 l 19.89794,-0.58238 21.25682,-1.8442 20.86857,-2.62071 4.7561,4.17372 0.19412,0.19412 0.87357,-0.38825 -0.67944,-3.78546 3.59133,-2.23245 1.45595,-9.90044 -1.45595,-0.67944 0.87357,-5.04728 4.36784,-0.87357 4.85316,-3.49427 2.13539,-6.11498 0.0971,-3.10602 -3.88252,-3.6884 -1.16476,-2.32951 -3.6884,-2.32952 0.19413,-0.48531 0.0971,-0.48532 z",
    "data-id": "IA",
    "data-name": "Iowa",
    id: "IA"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#cb1d1d",
      fillRule: "evenodd",
      strokeWidth: 0.97063118
    },
    d: "m 459.10856,291.38353 -2.42658,-41.0577 -4.36784,-2.52364 -0.38825,-1.94127 -3.49428,-3.10602 3.39721,-4.17371 -1.35888,-2.42658 -2.52364,0.0971 -2.32952,-1.65008 -0.97063,-0.7765 -3.30014,0.19412 -35.81629,1.35889 -16.40367,0.38825 h -32.61321 l -13.10352,-0.19413 -3.6884,-0.0971 v 1.8442 l -0.0971,5.72672 -1.0677,51.34639 v 1.94127 l 4.17372,0.0971 22.51864,0.29119 52.70528,-0.77651 37.56342,-1.74713 3.6884,-0.29119 -0.0971,-2.52364 z",
    "data-id": "KS",
    "data-name": "Kansas",
    id: "KS"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#68c95e",
      fillRule: "evenodd",
      strokeWidth: 0.97063118
    },
    d: "m 503.85466,221.10983 -4.7561,-4.17372 -20.86857,2.62071 -21.25682,1.8442 -19.89794,0.58238 v 0 l -0.0971,0.58238 2.42657,4.65903 2.23246,1.553 2.6207,4.65903 0.38825,0.38826 0.97063,0.7765 2.32952,1.65008 2.52364,-0.0971 1.35888,2.42658 -3.39721,4.17371 3.49428,3.10602 0.38825,1.94127 4.36784,2.52364 2.42658,41.0577 0.0971,2.52364 0.19413,2.52364 0.0971,2.52364 0.19413,2.6207 0.0971,2.52365 4.56197,-0.29119 31.25432,-2.52364 36.98105,-3.59134 1.8442,3.78546 -4.27078,6.79442 10.48282,-1.55301 h 0.0971 v -0.7765 l 0.19413,-4.46491 1.94126,-2.42658 -0.58238,-2.71776 -0.0971,-0.0971 -0.0971,-0.0971 0.38825,-1.26182 0.58238,0.19413 0.29119,0.7765 -0.0971,0.29119 v 0.0971 0.77651 l 0.38826,0.0971 0.7765,-0.97063 v -0.0971 l 0.0971,-0.29119 2.52364,-1.55301 0.38826,-0.19413 0.87357,-7.95917 -0.19413,-0.38826 -0.29119,-0.0971 -6.89148,-5.62966 1.06769,-2.03833 -1.94126,-5.53259 -3.49427,-2.71777 -6.60029,-2.9119 -4.17372,-3.3972 0.48532,-6.98855 1.26182,-6.50323 -6.98855,0.38825 -2.13539,-2.23245 -0.97063,-4.4649 -11.06519,-9.31806 -3.10602,-8.63862 0.7765,-4.27078 v 0 l -0.19412,-0.19412 z",
    "data-id": "MO",
    "data-name": "Missouri",
    id: "MO"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#c6c627",
      fillRule: "evenodd",
      strokeWidth: 0.97063118
    },
    d: "m 422.51576,183.35227 -3.00895,-3.00895 -10.57988,-3.10602 -3.39721,-0.0971 -5.14435,1.45594 -6.11498,-3.88252 -19.12143,0.19412 -27.85712,-0.29119 -32.90439,-1.06769 -2.9119,-0.0971 -0.0971,2.52364 -0.38825,7.57092 -0.87357,17.76255 -0.48532,10.19163 -0.0971,2.52364 2.32952,0.0971 23.6834,0.87357 4.65903,0.19413 -0.38826,19.02437 -0.0971,1.26182 3.6884,0.0971 13.10352,0.19413 h 32.61321 l 16.40367,-0.38825 35.81629,-1.35889 3.30014,-0.19412 -0.38825,-0.38826 -2.6207,-4.65903 -2.23246,-1.553 -2.42657,-4.65903 0.0971,-0.58238 v -0.29119 l -3.00896,-12.22996 0.58238,-1.94126 -3.30014,-4.56196 -0.19413,-5.43554 -3.00896,-4.75609 -3.10602,-9.12394 -0.67944,-0.0971 -1.8442,-0.19413 z",
    "data-id": "NE",
    "data-name": "Nebraska",
    id: "NE"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#cb1d1d",
      fillRule: "evenodd",
      strokeWidth: 0.97063118
    },
    d: "m 459.69094,301.57515 -0.19413,-2.6207 -0.0971,-2.52364 -0.19413,-2.52364 -3.6884,0.29119 -37.56342,1.74713 -52.70528,0.77651 -22.51864,-0.29119 -4.17372,-0.0971 h -1.55301 l -6.11497,-0.19413 -1.94127,-0.0971 -4.07665,-0.0971 -1.94126,-0.0971 -0.0971,2.52364 -0.0971,2.52364 -0.0971,2.52364 -0.0971,2.62071 h 0.58238 l 23.48927,0.58238 24.84816,0.29119 0.29119,33.19558 1.74714,5.82379 3.88252,3.6884 4.17372,0.19413 0.87356,-1.74714 5.72673,5.24141 7.47386,0.7765 1.35888,1.55301 2.71777,-1.26182 6.79442,3.20309 v 1.84419 l 2.52364,-0.0971 2.6207,-2.23245 4.85316,3.10602 4.56197,1.65007 3.10601,-4.27077 9.90044,4.65902 3.6884,-3.00895 3.00896,-1.16476 2.42658,0.58238 9.12393,-2.6207 4.85316,2.03832 4.36784,2.81483 3.78546,0.67944 h 0.0971 l -0.0971,-4.36784 -1.0677,-26.40117 -0.0971,-4.36784 -3.78546,-19.60675 -0.58238,-2.71776 -0.0971,-2.52365 z",
    "data-id": "OK",
    "data-name": "Oklahoma",
    id: "OK"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#68c95e",
      fillRule: "evenodd",
      strokeWidth: 0.97063118
    },
    d: "m 417.08023,114.24333 -16.40367,0.48532 -39.50469,0.29119 -42.80484,-1.16476 -3.78546,-0.19413 -0.0971,2.23246 -0.38825,8.83274 -0.29119,6.69736 -0.0971,1.35888 h -0.29119 l -0.0971,2.52364 -0.97063,20.38326 -0.7765,15.14184 -0.0971,2.62071 2.9119,0.0971 32.90439,1.06769 27.85712,0.29119 19.12143,-0.19412 6.11498,3.88252 5.14435,-1.45594 3.39721,0.0971 10.57988,3.10602 3.00895,3.00895 1.8442,0.19413 v -0.67944 l -2.13539,-3.20308 1.35889,-5.14435 -1.65008,-10.77401 2.03833,-0.0971 -0.19413,-4.4649 -4.85315,-34.16622 -2.52364,-4.27078 3.88252,-6.40616 0.0971,-0.29119 -3.30014,0.19412 z",
    "data-id": "SD",
    "data-name": "South Dakota",
    id: "SD"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#c6c627",
      fillRule: "evenodd",
      strokeWidth: 0.97063118
    },
    d: "m 539.18563,447.94634 -1.26182,0.29119 -0.58238,0.58238 z m 4.07665,0 -0.67944,-0.29119 -0.19412,0.29119 z m 2.32952,-0.77651 h -0.67944 l -0.38826,0.48532 z m -1.16476,-0.67944 -0.19413,-0.29119 -0.0971,0.29119 h 0.29119 z m 7.76505,-5.14434 -0.29119,0.19412 h 0.48532 z m 13.58884,-5.72673 0.58238,-0.7765 -0.67945,0.87357 0.0971,-0.0971 z m 1.94126,-2.52364 -0.19413,0.0971 v 0.0971 l 0.19413,-0.19413 z m -49.89044,8.54156 1.45594,-1.8442 -3.97959,-1.0677 -1.74713,1.45595 z m 40.28119,-8.44449 -0.38825,-0.38826 -0.0971,0.19413 0.48532,0.19413 z m 1.06769,-1.74714 -0.97063,-0.29119 0.29119,0.97063 z m 7.95918,-1.65007 v -0.29119 0.0971 0.19413 z m 1.94126,-1.26182 -0.0971,-0.0971 0.0971,0.19413 v -0.0971 z m -0.7765,-0.19413 -0.19413,-0.0971 -0.0971,0.29119 0.29119,-0.19413 z m -6.79442,-0.29119 0.87357,-0.29119 v -0.29119 z m 0.48532,-0.48532 0.48531,-0.48531 -0.0971,-0.0971 -0.38825,0.58237 z m -3.39721,-3.59133 -0.19413,0.19413 h 0.0971 l 0.0971,-0.19413 z m -35.8163,-54.35535 h -0.19412 l -36.5928,3.39721 -9.22099,0.67944 -3.00896,0.29119 0.0971,2.32952 1.94126,18.73318 3.20309,4.4649 0.0971,2.62071 3.10602,5.43553 2.52364,7.95918 -0.87357,4.4649 -0.67944,11.0652 -1.45594,3.59133 h 0.19412 l 0.29119,2.52364 -1.65007,2.32952 12.03582,-1.35889 9.41513,2.62071 6.69735,0.87357 3.39721,-2.42658 -1.8442,-2.42658 6.21204,-1.94126 -0.19412,2.13539 3.20308,-0.77651 2.6207,4.07665 2.23245,-0.7765 5.82379,3.97959 -3.59133,1.26182 8.25036,2.42657 h 3.10602 l 1.8442,-2.23245 3.97959,-2.13539 2.81483,4.07666 1.94126,-3.6884 -0.58238,-5.82379 5.24141,2.03833 0.58238,1.74713 6.21204,0.77651 3.10602,2.52364 -0.38825,2.03832 4.36784,-4.07665 -1.65008,-2.13539 -7.27973,-1.8442 -2.71777,-1.55301 -0.0971,-2.91189 3.00896,0.38825 2.32951,-4.75609 -3.00896,-4.17371 -1.65007,3.97958 -3.78546,-0.67944 2.6207,-4.27078 -1.74713,-0.48531 -4.27078,3.00896 -6.11498,0.38825 -1.74713,-1.35889 2.81483,-4.95021 3.30014,-0.0971 5.62967,1.8442 4.07665,0.38825 v 0 l -2.23245,-2.81483 -4.27078,-8.34742 1.16476,-4.65903 -33.48678,3.68839 1.26182,-1.26182 -1.35888,-3.49427 2.03832,-3.00896 1.16476,-7.57092 7.3768,-12.6182 -3.59134,-4.36784 0.19413,-3.20309 -2.23246,-5.24141 v -0.67944 z",
    "data-id": "LA",
    "data-name": "Louisiana",
    id: "LA"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#c6c627",
      fillRule: "evenodd",
      strokeWidth: 0.97063118
    },
    d: "m 424.16583,515.59933 -4.65902,-17.56842 v 3.30015 z m -1.06769,-30.86607 -3.30015,6.21204 -0.38825,2.03833 z m 2.6207,-4.56196 3.10602,-4.07666 -2.23245,1.35889 z m 10.96814,-9.90044 -7.27974,3.78546 2.03833,-0.38825 z m 0.97063,-1.35889 2.03832,-1.65007 -0.7765,0.19413 z m -115.11686,-162.87191 -0.67944,-0.0971 -3.30015,91.0452 -19.2185,-0.87357 -30.76901,-1.74713 -12.32701,-0.87357 2.42658,4.75609 0.0971,0.0971 10.48282,10.48281 6.01791,7.08561 7.95917,5.92085 5.62967,10.28869 2.13538,10.77401 4.56197,3.00895 3.59134,3.97959 5.14434,1.8442 7.47386,4.75609 3.39721,1.26183 4.65903,-4.65903 1.45595,-4.95022 2.42658,-4.7561 7.57092,-3.00895 2.91189,1.45594 8.44449,0.67945 7.66799,4.75609 5.24141,0.97063 -1.45595,2.71777 3.00896,1.94126 2.81483,3.39721 0.58238,3.59133 1.8442,2.42658 4.27077,10.28869 4.27078,3.59134 3.30015,5.43553 4.17371,4.27078 1.8442,0.58238 1.55301,11.06519 4.56197,2.52365 0.19412,3.49427 1.16476,-0.29119 7.95918,9.70631 3.97959,0.87357 5.04728,3.00896 h 7.76505 l 5.62966,3.10601 6.69735,-1.45594 -3.00895,-2.81483 -2.71777,-8.1533 -1.06769,-7.08561 -1.55301,-2.32952 0.67944,-4.75609 -2.03833,-0.19413 -2.71777,-4.4649 3.10602,3.30015 3.59134,-1.26182 1.94126,-5.14435 -3.88252,-5.24141 5.82378,0.67944 2.71777,-4.17371 -0.38825,-1.45595 2.42658,-3.20308 -0.58238,2.81483 2.71777,-2.13539 -1.0677,-3.78546 3.49427,1.8442 4.46491,-2.52364 -4.36784,-4.56197 2.71776,1.0677 5.04729,0.29119 6.60029,-1.45595 7.3768,-4.95022 4.4649,-3.6884 0.67944,-2.71777 2.71777,-2.81483 -1.45595,-4.65903 0.29119,-2.91189 4.85316,-2.13539 -0.38826,5.14435 h 2.9119 l -3.20308,2.71776 12.90939,-6.79441 2.13539,-0.0971 1.35888,-6.21204 h 0.38826 l 1.45594,-3.59133 0.67944,-11.0652 0.87357,-4.4649 -2.52364,-7.95918 -3.10602,-5.43553 -0.0971,-2.62071 -3.20309,-4.4649 -1.94126,-18.73318 -0.0971,-2.32952 -0.19413,-2.42658 -0.58238,-8.54155 -5.82378,0.19413 -1.45595,-1.55301 -0.29119,-0.0971 h -0.0971 l -3.78546,-0.67944 -4.36784,-2.81483 -4.85316,-2.03832 -9.12393,2.6207 -2.42658,-0.58238 -3.00896,1.16476 -3.6884,3.00895 -9.90044,-4.65902 -3.10601,4.27077 -4.56197,-1.65007 -4.85316,-3.10602 -2.6207,2.23245 -2.52364,0.0971 v -1.84419 l -6.79442,-3.20309 -2.71777,1.26182 -1.35888,-1.55301 -7.47386,-0.7765 -5.72673,-5.24141 -0.87356,1.74714 -4.17372,-0.19413 -3.88252,-3.6884 -1.74714,-5.82379 -0.29119,-33.19558 -24.84816,-0.29119 -23.48927,-0.58238 h -0.58238 z",
    "data-id": "TX",
    "data-name": "Texas",
    id: "TX"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#cb1d1d",
      fillRule: "evenodd",
      strokeWidth: 0.97063118
    },
    d: "m 787.1819,122.00838 -13.97709,5.33847 -0.19412,-0.48531 -7.86211,2.32951 -1.74714,0.48532 0.19413,0.97063 3.68839,14.26828 1.16476,1.45595 -2.52364,3.10602 1.74714,1.65007 v 0 l 5.62966,-5.43554 3.00895,-4.17371 0.58238,1.16476 14.17122,-6.30911 0.29119,-0.29118 -0.0971,-2.32952 -0.58237,-2.03833 -3.00896,-8.44449 -0.38825,-1.06769 -0.0971,-0.19413 z",
    "data-id": "CT",
    "data-name": "Connecticut",
    id: "CT"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#c6c627",
      fillRule: "evenodd",
      strokeWidth: 0.97063118
    },
    d: "m 774.07838,54.646573 -1.26182,1.55301 -1.45594,-0.29119 -0.77651,6.406166 v 0.09706 l 2.32952,8.735681 -0.19413,1.747136 -4.17372,5.532598 1.0677,5.047281 v 6.30911 l -0.77651,5.82378 4.36784,15.918365 v 0 0 l 3.97959,-1.26182 12.22996,-4.07666 5.53259,-6.01791 v 0 -1.553015 l 0.29119,-2.52364 -0.67944,0.29119 -0.0971,-0.58238 -6.11498,-7.47386 -0.19413,-0.67944 -14.07415,-33.001465 v 0 z",
    "data-id": "NH",
    "data-name": "New Hampshire",
    id: "NH"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#68c95e",
      fillRule: "evenodd",
      strokeWidth: 0.97063118
    },
    d: "m 796.69409,130.74406 -0.0971,-2.03832 -0.29119,0.7765 0.38825,1.26182 z m 1.94126,-1.55301 -1.26182,-2.42657 -0.0971,2.52364 1.35888,-0.0971 z m -0.58238,-3.00895 0.67944,1.74713 0.87357,1.55301 0.58238,-1.16475 -0.87357,-1.65008 -0.29119,-1.16475 h -0.97063 z m -10.774,-3.97959 0.38825,1.06769 3.00896,8.44449 0.58237,2.03833 0.0971,2.32952 0.19412,-0.29119 4.65903,-3.6884 -0.87356,-6.60029 1.94126,-0.38826 v 0 l -4.27078,-5.14434 -4.4649,1.74713 -1.26182,0.48532 z",
    "data-id": "RI",
    "data-name": "Rhode Island",
    id: "RI"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#cb1d1d",
      fillRule: "evenodd",
      strokeWidth: 0.97063118
    },
    d: "m 773.20481,111.52557 -4.36784,-15.918365 0.77651,-5.82378 v -6.30911 l -1.0677,-5.047278 4.17372,-5.532598 0.19413,-1.747136 -2.32952,-8.735681 -1.26182,0.485316 -5.33847,1.941262 -5.24141,2.038326 -12.03583,4.36784 -0.67944,0.194126 4.36784,10.191633 1.45595,9.60924 5.14434,8.05624 4.85316,15.918355 0.19413,-0.0971 0.7765,-0.29119 2.23245,-0.67944 1.94126,-0.67944 5.5326,-1.65007 0.67944,-0.29119 v 0 z",
    "data-id": "VT",
    "data-name": "Vermont",
    id: "VT"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#c6c627",
      fillRule: "evenodd",
      strokeWidth: 0.97063118
    },
    d: "m 568.49869,323.51142 0.38826,0.77651 1.35888,0.87356 0.58238,39.79588 0.19413,21.8392 4.95021,29.89545 0.38826,-0.0971 4.36784,0.87357 1.16475,-8.63862 1.94127,4.85316 3.30014,3.00896 6.30911,-3.6884 -0.67945,-0.58238 0.19413,0.0971 -4.36784,-9.9975 41.93127,-6.79442 2.81483,-0.48531 v -0.0971 l -2.62071,-4.95022 -0.19412,-7.0856 -2.13539,-3.88253 1.06769,-7.57092 1.74714,-1.94126 -7.18267,-12.81234 -13.00646,-39.60175 -0.0971,-0.19413 -2.9119,0.48532 -15.5301,2.52364 -7.76504,0.97063 -16.30661,2.23245 0.0971,0.19413 z",
    "data-id": "AL",
    "data-name": "Alabama",
    id: "AL"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#68c95e",
      fillRule: "evenodd",
      strokeWidth: 0.97063118
    },
    d: "m 704.87238,513.94926 h -0.19413 l 0.0971,0.0971 0.0971,-0.0971 z m -0.87357,-0.0971 v 0.0971 h 0.0971 z m 0.19413,-0.0971 v -0.0971 z m -13.20059,1.45594 v 0 0.0971 z m -0.19412,0.0971 v -0.0971 z m 0.0971,-0.0971 z m -0.97063,0.0971 h -0.0971 v 0.0971 z m 27.56592,-6.11498 h -0.0971 l 0.0971,0.19412 z m 2.62071,-0.67944 v -0.19413 l -0.19413,0.29119 0.19413,-0.0971 z m -0.97063,-0.19413 -0.38826,-0.38825 -0.0971,0.0971 0.48532,0.29119 z m -0.29119,0.77651 -1.16476,-1.45595 0.67944,1.26182 z m 9.22099,-5.72673 v 0.38825 l 0.19413,-0.19412 z m 1.35889,-0.97063 0.29119,-0.48532 -0.38826,0.38826 0.0971,0.0971 z m 0.29119,-0.97063 h -0.0971 v 0.0971 z m -1.74714,-0.29119 -0.0971,-0.0971 z m 0.87357,-1.45595 -0.0971,-0.0971 v 0.19413 l 0.0971,-0.0971 z m -2.62071,-0.0971 -0.0971,-0.0971 z m 3.30015,-2.23245 -0.19413,0.0971 0.29119,0.0971 -0.0971,-0.19412 z m 0.38825,0 -0.19412,-0.19413 0.0971,0.29119 0.0971,-0.0971 z m -0.67944,-0.19413 -0.0971,-0.0971 v 0.19412 l 0.0971,-0.0971 z m 3.59134,-0.67944 v -0.0971 l -0.19413,0.38825 0.19413,-0.29119 z m -4.07665,0.38825 h -0.19413 l 0.19413,0.0971 z m 2.03832,-1.16476 h -0.29119 l -0.0971,0.0971 0.38825,-0.0971 z m 0.77651,-0.48531 v 0 h -0.0971 z m -8.15331,0.38825 v -0.19412 l -0.0971,0.19412 z m 0.87357,-0.29119 h -0.29119 l 0.29119,0.58238 z m -2.32951,0.0971 v -0.58238 l -0.48532,0.0971 0.48532,0.48532 z m -1.35889,-0.97064 0.48532,0.48532 v -0.19413 z m 14.26828,0.58238 -1.74713,0.77651 0.58237,0.0971 1.16476,-0.87357 z m -13.58883,-0.87356 h -0.58238 v 0.19412 z m 15.33597,-4.85316 0.0971,-0.48532 0.0971,-1.26182 -0.19412,1.74714 z m 0.0971,-5.43554 -0.38825,-0.97063 -0.19413,0.38826 z m -22.42158,2.42658 -0.19413,0.29119 0.48532,0.0971 -0.29119,-0.38825 z m -1.8442,-0.87357 -0.87357,0.29119 0.67945,0.0971 0.19412,-0.38826 z m -1.94126,0.19413 v -0.29119 l -0.0971,0.0971 0.0971,0.19413 z m -2.03833,-0.0971 -0.58238,0.38825 0.77651,0.38825 z m 2.71777,0.0971 -0.0971,-0.29119 -0.48532,-0.0971 0.58238,0.38825 z m -12.71527,-9.51219 -0.58238,0.29119 1.16476,0.38826 z m -2.32951,-3.10602 -0.77651,-1.16475 0.29119,0.87357 z m 3.00895,1.94127 -1.35888,-3.10602 -0.97063,-0.29119 z m -3.88252,-3.88253 -0.29119,-0.7765 -0.19413,-0.48532 z m -8.05624,-10.774 -1.74714,-1.26182 0.67945,0.67944 z m 43.6784,-6.50323 -7.0856,-11.8417 h -0.38826 z m -49.01687,-18.92731 -0.29119,-0.0971 0.29119,0.19412 v -0.0971 z m -0.58238,-0.67944 -0.0971,0.0971 0.0971,0.0971 v -0.19412 z m -0.67944,-0.97063 v -0.0971 l -0.0971,0.0971 z m 0.38825,-0.38826 0.29119,0.19413 v -0.19413 z m 0.58238,-0.38825 -0.38825,0.0971 h 0.0971 l 0.29119,-0.0971 z m -0.67944,-0.0971 -0.29119,-0.29119 0.0971,0.0971 0.19413,0.19413 z m -0.67944,-1.0677 h -0.19413 l 0.29119,0.0971 -0.0971,-0.0971 z m 0.67944,-1.16475 h -0.38826 l -0.0971,0.0971 0.48532,-0.0971 z m 0.38825,0.19412 -0.48532,-0.48531 0.19413,0.0971 0.29119,0.38825 z m -3.6884,-4.17371 -0.19413,-0.0971 v 0.0971 z m -4.17371,0 -0.29119,-0.38825 0.0971,0.48531 0.19413,-0.0971 z m -35.33098,-3.20309 2.91189,-2.23245 -3.20308,2.13539 0.29119,0.0971 z m 5.82379,-4.65902 0.29119,-0.29119 -1.16476,0.48531 z m -36.88399,-6.50323 -10.57988,3.39721 5.82379,-1.65008 z m 26.30411,-16.50073 -2.81483,0.48531 -41.93127,6.79442 4.36784,9.9975 0.29119,0.0971 -1.06769,3.97959 3.10602,-1.35888 3.3972,-3.00896 5.82379,-0.19412 6.69736,-2.42658 4.56196,0.67944 -1.06769,1.65007 8.34743,2.81483 7.18267,3.49428 1.65007,3.88252 5.33847,-1.16476 12.61821,-10.28869 4.65903,0.19413 19.02437,14.36534 3.88252,-0.77651 4.07666,5.43554 0.7765,8.63862 -1.26182,5.43553 0.58238,2.71777 3.39721,6.79442 -1.55301,-5.33847 4.36784,-0.0971 0.38825,3.88253 -2.32951,6.01791 8.05624,11.0652 3.00895,0.0971 -2.52364,-3.39721 3.10602,0.38825 1.8442,-1.16475 -0.7765,6.21204 4.17371,3.30014 2.81483,7.57093 3.78546,2.32951 4.85316,1.26182 6.69735,8.54156 3.49428,1.84419 -4.65903,0.29119 2.13538,2.42658 7.66799,-2.52364 3.78546,-2.13539 3.49427,-12.22995 -1.74713,-19.02437 -0.38825,-1.94127 -9.31806,-15.53009 -7.95918,-11.25933 -4.4649,-9.22099 3.78546,3.20308 0.7765,-0.58238 1.65008,8.05624 4.27077,6.11498 -4.17371,-8.1533 0.19413,-3.88253 -12.52115,-15.23891 -3.00895,-4.75609 -3.97959,-8.05624 -2.71777,-6.79442 -2.13539,-2.42658 -0.48531,-3.10602 -0.0971,-0.0971 -6.69735,-0.38825 -2.62071,2.03832 -1.45594,7.47386 -1.35889,-3.49427 -45.81379,5.72672 -3.30014,-5.14434 0.0971,-0.0971 z",
    "data-id": "FL",
    "data-name": "Florida",
    id: "FL"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#68c95e",
      fillRule: "evenodd",
      strokeWidth: 0.97063118
    },
    d: "m 696.03963,374.76075 -0.0971,-2.9119 -0.67944,2.52364 0.7765,0.38826 z m 1.0677,-4.46491 -0.38825,-2.23245 -0.29119,1.35889 z m -45.42554,-61.14976 -1.26182,0.29119 -3.6884,0.7765 -13.58884,2.81483 -1.26182,0.29119 -1.35888,0.19413 -7.57093,1.45595 -2.03832,0.38825 -8.25037,1.55301 -1.74713,0.19412 0.0971,0.19413 13.00646,39.60175 7.18267,12.81234 -1.74714,1.94126 -1.06769,7.57092 2.13539,3.88253 0.19412,7.0856 2.62071,4.95022 v 0.0971 l -0.0971,0.0971 3.30014,5.14434 45.81379,-5.72672 1.35889,3.49427 1.45594,-7.47386 2.62071,-2.03832 6.69735,0.38825 v 0 l -0.58237,-10.48282 1.26182,-2.23245 -0.67945,-4.17371 1.35889,-3.97959 2.03832,-2.23245 -1.45594,-1.35889 3.39721,-4.17371 h -0.0971 l -5.82378,-5.43554 -7.95918,-11.35638 -4.36784,-2.03833 -18.73318,-15.72422 -4.56197,-5.82379 -8.83274,-3.6884 -0.48532,-1.94126 2.71777,-5.33847 v 0 z",
    "data-id": "GA",
    "data-name": "Georgia",
    id: "GA"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#68c95e",
      fillRule: "evenodd",
      strokeWidth: 0.97063118
    },
    d: "m 566.94568,421.44811 -0.48531,0.0971 v 0.0971 l 0.48531,-0.19412 z m 9.02687,-1.16476 h -1.35888 l 1.26182,0.0971 0.0971,-0.0971 z m -11.25932,0.97063 -0.38825,0.38825 0.0971,0.0971 0.29119,-0.48532 z m 9.12394,-0.7765 h -3.6884 l 3.49427,0.0971 z m -40.47533,-92.50116 v 0.0971 l -4.07665,6.79442 0.38826,5.2414 -5.5326,6.11498 1.45595,1.74714 -3.6884,15.5301 1.74713,3.30014 -0.97063,0.67944 0.0971,2.13539 v 0.67944 l 2.23246,5.24141 -0.19413,3.20309 3.59134,4.36784 -7.3768,12.6182 -1.16476,7.57092 -2.03832,3.00896 1.35888,3.49427 -1.26182,1.26182 33.48678,-3.68839 -1.16476,4.65903 4.27078,8.34742 2.23245,2.81483 v -0.0971 l 3.59133,-4.07665 7.57093,-1.65007 6.98854,0.7765 1.06769,-1.35888 v -0.0971 l -4.95021,-29.89545 -0.19413,-21.8392 -0.58238,-39.79588 -1.35888,-0.87356 -0.38826,-0.77651 h -0.19412 l -4.85316,0.67944 -8.54155,1.16476 -19.41263,2.42658 -2.13539,0.19412 z",
    "data-id": "MS",
    "data-name": "Mississippi",
    id: "MS"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#c6c627",
      fillRule: "evenodd",
      strokeWidth: 0.97063118
    },
    d: "m 651.68179,309.14608 v 0 l -2.71777,5.33847 0.48532,1.94126 8.83274,3.6884 4.56197,5.82379 18.73318,15.72422 4.36784,2.03833 7.95918,11.35638 5.82378,5.43554 v 0 l 0.97063,-4.4649 -1.55301,-4.27078 4.17372,3.10602 2.32951,-1.8442 -3.97959,-3.30015 4.85316,-0.29119 7.57092,-6.40616 -0.87356,-1.65008 4.65903,-3.59133 -0.48532,-1.74714 3.39721,-2.13539 0.19413,-4.95022 5.33847,-9.90043 3.59133,-4.56197 0.38826,-0.19413 -21.64508,-13.6859 -8.05624,1.55301 -10.96813,-0.38825 -5.43554,-2.81483 -32.22495,10.19163 z",
    "data-id": "SC",
    "data-name": "South Carolina",
    id: "SC"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#cb1d1d",
      fillRule: "evenodd",
      strokeWidth: 0.97063118
    },
    d: "m 511.61971,176.84905 -0.19413,0.48531 3.6884,2.32952 1.16476,2.32951 3.88252,3.6884 -0.0971,3.10602 -2.13539,6.11498 -4.85316,3.49427 -4.36784,0.87357 -0.87357,5.04728 1.45595,0.67944 -1.45595,9.90044 -3.59133,2.23245 0.67944,3.78546 -0.87357,0.38825 v 0 l -0.7765,4.27078 3.10602,8.63862 11.06519,9.31806 0.97063,4.4649 2.13539,2.23245 6.98855,-0.38825 -1.26182,6.50323 -0.48532,6.98855 4.17372,3.3972 6.60029,2.9119 3.49427,2.71777 1.94126,5.53259 -1.06769,2.03833 6.89148,5.62966 0.29119,0.0971 -0.58238,-0.58238 1.94126,-4.56196 7.47386,2.03832 1.8442,-2.13539 -1.45594,-4.27077 6.11497,-3.59134 -1.65007,-2.32951 1.45595,-3.30015 v -0.29119 l -0.38826,-0.0971 0.0971,-8.63862 2.13539,-1.55301 3.68839,-8.63862 -0.7765,-3.78546 -2.42658,-4.56196 1.35888,-5.14435 -6.79441,-47.85212 -0.97064,-1.06769 -2.52364,-5.72673 -2.03832,-2.13539 -0.87357,-5.62966 v -0.19412 l -13.10352,1.8442 -7.86211,0.97063 -21.15976,2.42658 v 0 z",
    "data-id": "IL",
    "data-name": "Illinois",
    id: "IL"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#68c95e",
      fillRule: "evenodd",
      strokeWidth: 0.97063118
    },
    d: "m 600.52952,178.88737 -14.85065,2.62071 -3.39721,0.67944 -12.03583,1.94126 -2.52364,2.03833 -3.78546,1.74713 -1.45595,-0.0971 -1.74714,-0.87357 -0.58237,-0.58238 6.79441,47.85212 -1.35888,5.14435 2.42658,4.56196 0.7765,3.78546 -3.68839,8.63862 -2.13539,1.55301 -0.0971,8.63862 0.38826,0.0971 0.38825,-0.0971 1.45595,-2.71777 h 3.59133 l 4.36784,-1.45595 5.43554,2.03833 0.58237,-2.23245 3.10602,-2.32952 4.65903,0.67945 2.52365,-4.95022 6.89148,0.58237 -0.0971,-2.81483 6.11498,-8.05623 -0.97063,-3.6884 4.27078,-0.0971 5.2414,-4.17371 -1.26182,-4.75609 0.19413,-0.19413 -0.19413,-1.65007 -5.82378,-34.36035 -2.62071,-14.65653 -0.29119,-1.55301 -0.29119,-1.26182 z",
    "data-id": "IN",
    "data-name": "Indiana",
    id: "IN"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#cb1d1d",
      fillRule: "evenodd",
      strokeWidth: 0.97063118
    },
    d: "m 543.35935,295.84843 -0.29119,-0.7765 -0.58238,-0.19413 -0.38825,1.26182 0.0971,0.0971 1.06769,-0.0971 0.0971,-0.29119 z m 66.39117,-63.47928 -0.19413,0.19413 1.26182,4.75609 -5.2414,4.17371 -4.27078,0.0971 0.97063,3.6884 -6.11498,8.05623 0.0971,2.81483 -6.89148,-0.58237 -2.52365,4.95022 -4.65903,-0.67945 -3.10602,2.32952 -0.58237,2.23245 -5.43554,-2.03833 -4.36784,1.45595 h -3.59133 l -1.45595,2.71777 -0.38825,0.0971 v 0.29119 l -1.45595,3.30015 1.65007,2.32951 -6.11497,3.59134 1.45594,4.27077 -1.8442,2.13539 -7.47386,-2.03832 -1.94126,4.56196 0.58238,0.58238 0.19413,0.38826 -0.87357,7.95917 -0.38826,0.19413 -2.52364,1.55301 -0.0971,0.29119 2.81483,-0.38826 19.60675,-2.6207 -0.97063,-3.88252 3.30015,-0.0971 39.50469,-5.24141 27.76005,-4.65903 0.38825,-0.29119 0.67944,-0.7765 7.27974,-3.88252 5.62966,-7.3768 0.7765,-2.52364 3.6884,-2.9119 4.65903,-5.92085 0.67944,-0.97063 -0.29119,-0.0971 h -2.42657 l -3.10602,-1.74714 -5.5326,-6.69735 -1.94126,-6.79442 v -0.19413 l -0.19413,-0.19412 -4.07665,-2.32952 -1.8442,-3.10602 -3.6884,3.59134 -2.32951,0.58238 -2.9119,-1.16476 -2.52364,1.94126 -5.24141,-2.32951 -1.35888,0.58237 -4.95022,-4.27077 -2.52364,-1.26182 -4.75609,0.58238 -0.77651,0.7765 z",
    "data-id": "KY",
    "data-name": "Kentucky",
    id: "KY"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#c6c627",
      fillRule: "evenodd",
      strokeWidth: 0.97063118
    },
    d: "m 740.39748,310.89321 -1.06769,1.0677 0.19412,0.19413 z m 0.7765,-5.62966 -0.48531,0.77651 0.19413,0.7765 z m 5.82379,-9.02687 -1.45594,0.97063 -0.77651,1.16476 z m 12.52114,-6.11497 -0.58237,-0.38826 -1.26182,-0.0971 1.84419,0.48532 z m -2.6207,-0.58238 h -0.87357 l -1.45594,0.7765 z m 3.00896,1.06769 2.81483,-6.98854 -1.94126,2.91189 z m 4.17371,-9.22099 1.26182,-1.8442 h -0.67944 z m 8.1533,-7.57093 -2.13539,-10.774 1.8442,5.62966 z m -11.8417,-24.55697 -0.19412,0.0971 -0.29119,0.0971 v 0 h 0.0971 l 5.33847,9.02687 4.17372,4.17371 -9.12394,-13.39471 v 0 z m -1.74713,0.58238 -0.77651,0.19413 v 0 l 0.19413,0.0971 h 1.65007 l -0.19413,-0.58238 v 0 l -0.29118,0.0971 h -0.29119 v 0 0.19412 l -0.19413,0.0971 -0.0971,-0.0971 v 0 z m -89.78339,22.13039 -0.48532,1.45595 0.0971,4.17371 -1.0677,-0.0971 -2.52364,5.14435 -2.81483,0.29119 -5.24141,5.14434 -2.32951,-0.87357 -3.00896,4.46491 -7.95917,7.18267 -3.88253,0.97063 -4.07665,3.78546 -0.19413,2.52364 -3.59133,1.94126 0.0971,4.27078 v 0.97063 l 1.26182,-0.29119 13.58884,-2.81483 3.6884,-0.7765 1.26182,-0.29119 h 0.29119 l 32.22495,-10.19163 5.43554,2.81483 10.96813,0.38825 8.05624,-1.55301 21.64508,13.6859 0.38825,-0.29119 9.9975,-4.07665 0.0971,-5.33847 3.59134,-6.50323 3.88252,-3.6884 8.05624,-5.33847 1.0677,-1.94126 2.13538,0.97063 0.97064,-6.40616 -1.16476,2.23245 -4.07665,1.35888 -3.88253,0.0971 4.7561,-3.49427 -1.45595,-1.55301 1.65007,-3.49427 -9.12393,-1.45595 -0.38825,-0.48531 7.76505,-1.45595 2.52364,1.26182 3.20308,-0.29119 2.6207,-1.94126 1.94127,-3.78546 1.74713,-0.48532 -0.29119,-5.33847 -2.23245,-2.13539 -2.23245,2.03833 0.48531,5.14434 -1.65007,-6.3091 -1.26182,-0.29119 -9.60925,3.97959 4.27078,-4.17372 0.19413,-1.65007 4.4649,-1.06769 1.26182,-3.30015 3.00896,1.74714 -3.20309,-4.7561 -2.23245,-1.94126 v 0 l -38.82525,11.0652 -24.75109,6.3091 -25.04229,4.65903 -0.0971,-0.19413 z",
    "data-id": "NC",
    "data-name": "North Carolina",
    id: "NC"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#c6c627",
      fillRule: "evenodd",
      strokeWidth: 0.97063118
    },
    d: "m 668.37664,185.29354 -2.42657,-10.48282 -0.48532,-2.13539 -2.71777,-11.93876 -3.49427,2.23245 -7.47386,5.72672 -4.85315,5.92085 -3.78547,0.58238 -6.98854,3.97959 -3.88253,-2.32951 -11.74463,-1.35889 v 0 l -6.21204,1.55301 -6.11498,1.45595 -6.40617,1.35888 -0.97063,0.29119 0.29119,1.55301 2.62071,14.65653 5.82378,34.36035 0.19413,1.65007 0.77651,-0.7765 4.75609,-0.58238 2.52364,1.26182 4.95022,4.27077 1.35888,-0.58237 5.24141,2.32951 2.52364,-1.94126 2.9119,1.16476 2.32951,-0.58238 3.6884,-3.59134 1.8442,3.10602 4.07665,2.32952 0.19413,0.19412 v 0 l 4.17371,-2.03832 1.45595,-3.20309 -1.16476,-3.30014 3.30014,-5.04728 2.42658,-0.38826 -0.29119,-4.27077 3.97959,-5.43554 0.67944,0.77651 3.59134,-2.71777 3.10602,-4.65903 0.48531,-21.25682 0.19413,-0.0971 -0.48532,-2.03832 z",
    "data-id": "OH",
    "data-name": "Ohio",
    id: "OH"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#cb1d1d",
      fillRule: "evenodd",
      strokeWidth: 0.97063118
    },
    d: "m 636.44288,279.15357 -27.76005,4.65903 -39.50469,5.24141 -3.30015,0.0971 0.97063,3.88252 -19.60675,2.6207 -2.81483,0.38826 v 0.0971 l -0.7765,0.97063 -0.38826,-0.0971 v -0.77651 -0.0971 l -1.06769,0.0971 0.0971,0.0971 0.58238,2.71776 -1.94126,2.42658 -0.19413,4.46491 v 0.7765 0.0971 l -2.91189,5.62966 0.58238,3.97959 -2.71777,4.27078 0.97063,3.88252 -3.49427,3.20309 0.19412,0.19412 2.13539,-0.19412 19.41263,-2.42658 8.54155,-1.16476 4.85316,-0.67944 h 0.19412 l -0.0971,-0.19413 16.30661,-2.23245 7.76504,-0.97063 15.5301,-2.52364 2.9119,-0.48532 1.74713,-0.19412 8.25037,-1.55301 2.03832,-0.38825 7.57093,-1.45595 1.35888,-0.19413 v -0.97063 l -0.0971,-4.27078 3.59133,-1.94126 0.19413,-2.52364 4.07665,-3.78546 3.88253,-0.97063 7.95917,-7.18267 3.00896,-4.46491 2.32951,0.87357 5.24141,-5.14434 2.81483,-0.29119 2.52364,-5.14435 1.0677,0.0971 -0.0971,-4.17371 0.48532,-1.45595 -1.55301,0.29119 -5.5326,1.55301 -6.60029,1.35889 -16.59779,3.39721 -1.74714,0.29118 -0.38825,0.29119 z",
    "data-id": "TN",
    "data-name": "Tennessee",
    id: "TN"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#cb1d1d",
      fillRule: "evenodd",
      strokeWidth: 0.97063118
    },
    d: "m 758.93654,249.64639 h 0.29119 l 0.29118,-0.0971 v 0 l -0.19412,-0.48531 -0.38825,0.58238 v 0 z m -3.30015,-10.87107 v 0.48531 l 0.48532,-0.29119 z m 1.74714,-3.39721 -0.0971,-0.77651 v 0 z m -0.58238,1.16475 -0.19413,1.26183 -0.29119,0.48531 z m 0.87357,-2.52364 0.0971,-0.58238 -0.19413,0.58238 h 0.0971 z m 0.58237,-2.6207 0.29119,-0.67944 -0.48531,1.74713 z m 0.0971,-1.45595 0.38825,-2.13539 -0.48532,0.48532 0.0971,1.65007 z m 1.74713,-9.60925 0.19413,-0.87356 -0.0971,0.19412 -0.0971,0.67944 z m -0.38825,-2.23245 -1.26182,0.48532 -1.94126,0.87357 -0.67944,0.87356 0.29119,0.0971 -2.32952,14.4624 0.87357,2.32952 1.35888,-6.01792 2.52364,-7.86211 1.16476,-5.14435 v -0.0971 z m 1.94126,-0.7765 -0.29119,0.0971 -0.0971,0.38825 -0.48531,3.00896 0.38825,-1.0677 0.48531,-2.42657 z m -101.43096,37.17517 -0.67944,0.97063 -4.65903,5.92085 -3.6884,2.9119 -0.7765,2.52364 -5.62966,7.3768 -7.27974,3.88252 -0.67944,0.7765 1.74714,-0.29118 16.59779,-3.39721 6.60029,-1.35889 5.5326,-1.55301 1.55301,-0.29119 0.0971,0.19413 25.04229,-4.65903 24.75109,-6.3091 38.82525,-11.0652 v 0 l -0.29119,-0.48531 -0.0971,-0.29119 0.67944,0.67944 v 0 0 l 0.77651,-0.19413 -0.0971,-0.0971 -0.67944,-3.30015 0.48532,0.0971 1.55301,2.91189 v 0 0 l 0.29119,-0.0971 0.19412,-0.0971 -0.38825,-0.7765 -3.97959,-6.11498 -4.95022,0.87357 -2.23245,1.8442 -2.13539,-1.94126 -7.27973,-2.42658 -5.04728,-0.19413 9.80337,-0.87357 5.43554,3.6884 1.55301,-2.42658 -4.36784,-5.53259 3.10602,0.19412 -1.65008,-4.4649 -3.88252,0.19413 -9.221,-7.47386 h -1.16476 l 13.00646,6.40616 -0.87357,-4.4649 0.87357,-1.45595 -6.60029,-2.52364 -5.72672,-0.38825 -2.81483,-2.52364 -2.32952,1.45594 -0.87357,-6.69735 0.97063,0.19412 -0.19412,-5.43553 -0.19413,-0.19413 -0.19413,0.0971 -0.19412,-0.0971 -0.48532,-0.38825 -0.29119,-0.29119 -3.10602,-1.35888 -3.20308,-2.32952 -4.4649,-1.16475 -0.29119,-0.0971 v 0.0971 l -0.58238,4.07665 -9.02687,-3.88253 0.19413,5.62966 -4.95022,9.41513 -3.00896,3.30014 -1.94126,5.72673 -5.92085,-2.03833 -2.9119,13.20058 -2.32951,4.46491 -0.38825,5.82379 -1.74714,2.81483 -6.50323,1.94126 -5.33847,4.17371 -2.52364,0.38825 -2.42658,2.13539 -6.11498,-2.23245 -1.06769,-3.00896 -0.19413,-0.0971 z",
    "data-id": "VA",
    "data-name": "Virginia",
    id: "VA"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#68c95e",
      fillRule: "evenodd",
      strokeWidth: 0.97063118
    },
    d: "m 555.97755,113.46683 -2.42658,3.00896 -1.45594,4.36784 0.67944,2.42657 z m -55.71423,-22.809835 1.45595,-2.03833 -1.0677,0.97063 z m 2.23245,-3.20309 -0.48531,-0.58238 -1.0677,0.67945 1.55301,-0.0971 z m -21.15976,5.43554 -2.23245,2.52364 1.0677,11.647575 -6.21204,5.62966 -1.16476,5.43554 3.39721,3.10602 -0.97063,13.39471 3.59133,2.71777 2.32952,0.19412 7.37679,4.46491 4.65903,4.85315 5.92085,3.00896 1.35889,7.47386 v 0.48531 0 l 2.81483,3.39721 -0.77651,2.62071 0.97063,5.72672 2.9119,3.97959 5.33847,2.81483 -0.0971,0.48532 v 0 l 21.15976,-2.42658 7.86211,-0.97063 13.10352,-1.8442 -0.38825,-1.45595 v -4.56197 l -2.62071,-4.85315 -0.67944,-6.11498 1.26182,-6.79442 -0.67944,-5.24141 2.32952,-6.50322 -0.87357,-1.0677 0.19412,-6.01791 1.26182,-4.56197 -1.45594,-1.55301 -2.81483,0.97063 -1.55301,4.07665 -3.6884,2.13539 1.16476,-5.14434 3.30014,-4.36784 0.19413,-1.94127 0.0971,-0.0971 -4.65903,-4.65903 v -6.60029 l -5.24141,-4.27078 -7.18267,-0.48531 -7.3768,-1.94127 -15.91835,-4.853155 -3.10602,-1.74714 -0.29119,0.29119 -4.95022,-0.67944 -1.65007,0.97063 0.67944,-7.08561 -7.95917,4.07665 -9.70631,1.55301 -0.0971,-0.19412 z m 19.02437,-5.14435 -0.19412,-0.67944 -0.67944,0.29119 z m -3.49427,-0.67944 0.29119,-0.58238 -0.19413,-0.19413 -0.0971,0.77651 z m 7.08561,-1.65007 -0.29119,-1.35889 -0.29119,1.65008 z",
    "data-id": "WI",
    "data-name": "Wisconsin",
    id: "WI"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#c6c627",
      fillRule: "evenodd",
      strokeWidth: 0.97063118
    },
    d: "m 686.9157,202.37665 -13.78296,3.39721 -4.27078,-18.442 v 0 l -0.19413,0.0971 -0.48531,21.25682 -3.10602,4.65903 -3.59134,2.71777 -0.67944,-0.77651 -3.97959,5.43554 0.29119,4.27077 -2.42658,0.38826 -3.30014,5.04728 1.16476,3.30014 -1.45595,3.20309 -4.17371,2.03832 v 0 0.19413 l 1.94126,6.79442 5.5326,6.69735 3.10602,1.74714 h 2.42657 l 0.29119,0.0971 0.19413,0.0971 1.06769,3.00896 6.11498,2.23245 2.42658,-2.13539 2.52364,-0.38825 5.33847,-4.17371 6.50323,-1.94126 1.74714,-2.81483 0.38825,-5.82379 2.32951,-4.46491 2.9119,-13.20058 5.92085,2.03833 1.94126,-5.72673 3.00896,-3.30014 4.95022,-9.41513 -0.19413,-5.62966 9.02687,3.88253 0.58238,-4.07665 v -0.0971 0 l -2.81483,-4.85315 -5.82379,-0.67945 -3.39721,2.62071 v 1.94126 l -2.91189,0.67944 -4.27078,3.00896 -2.23245,0.48532 -4.46491,6.3091 -2.23245,-10.19163 -1.94126,0.48532 z",
    "data-id": "WV",
    "data-name": "West Virginia",
    id: "WV"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#cb1d1d",
      fillRule: "evenodd",
      strokeWidth: 0.97063118
    },
    d: "m 743.98882,186.36123 0.38825,1.45595 8.05624,23.00396 9.22099,-2.71777 -0.0971,-0.19413 h 0.19413 l 0.29119,0.0971 v 0 l 0.19412,-0.0971 -0.19412,-0.38825 -2.32952,-6.21204 -11.35638,-10.774 0.48531,-7.47386 v 0 h -2.32951 l -1.74714,1.35888 -0.7765,1.94126 v 0 z",
    "data-id": "DE",
    "data-name": "Delaware",
    id: "DE"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#cb1d1d",
      fillRule: "evenodd",
      strokeWidth: 0.97063118
    },
    d: "m 728.36165,207.81218 0.48532,0.38825 0.19412,0.0971 0.19413,-0.0971 0.19413,0.0971 0.67944,0.38825 0.19413,0.29119 v 0.67944 l 0.19412,0.38825 1.26182,-2.32951 -1.35888,-0.77651 -1.65007,0.0971 -0.38826,0.7765 z",
    "data-id": "DC",
    "data-name": "District of Columbia",
    id: "DC"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#cb1d1d",
      fillRule: "evenodd",
      strokeWidth: 0.97063118
    },
    d: "m 761.75137,216.93611 0.67944,-5.2414 -0.58238,3.88252 -0.38825,1.65007 -0.0971,0.19413 0.29119,-0.0971 0.0971,-0.38826 z m 0.48531,-9.02687 -0.19412,0.0971 0.19412,0.58238 v 1.16475 -1.8442 0 z m -73.37972,-6.01791 2.23245,10.19163 4.46491,-6.3091 2.23245,-0.48532 4.27078,-3.00896 2.91189,-0.67944 v -1.94126 l 3.39721,-2.62071 5.82379,0.67945 2.81483,4.85315 v 0 l 0.29119,0.0971 4.4649,1.16475 3.20308,2.32952 3.10602,1.35888 0.29119,0.29119 0.38826,-0.7765 1.65007,-0.0971 1.35888,0.77651 -1.26182,2.32951 v 0.0971 l -1.8442,5.62966 6.01792,3.88252 6.01791,0.29119 3.97959,1.8442 -1.65008,-4.65903 -5.14434,-1.74714 -1.26182,-3.97958 3.20308,4.27077 2.62071,0.38826 -2.32952,-2.32952 -1.8442,-6.89148 0.48532,-3.97959 -2.03833,-4.36784 2.13539,-1.74713 1.55301,-5.62967 -0.58238,8.34743 1.65007,2.81483 1.55301,-3.30014 0.87357,5.43553 -1.65007,3.97959 4.75609,1.74714 -4.07665,1.35888 2.13539,3.97959 3.49427,1.16475 1.94126,-3.3972 -0.19412,4.75609 3.30014,-0.0971 2.13539,2.42657 h 0.0971 l 0.67944,-0.87356 1.94126,-0.87357 1.26182,-0.48532 -0.0971,-0.19412 2.52364,-7.47386 v -0.29119 l -0.48532,-1.94127 v -0.0971 l -9.22099,2.71777 -8.05624,-23.00396 -0.38825,-1.45595 -1.65008,0.48532 -6.89148,2.13539 -37.95168,10.57988 -6.89148,1.8442 -1.74714,0.48531 z",
    "data-id": "MD",
    "data-name": "Maryland",
    id: "MD"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#68c95e",
      fillRule: "evenodd",
      strokeWidth: 0.97063118
    },
    d: "m 766.99277,185.97298 -0.48531,-1.16476 v 1.16476 z m 0.97064,-3.59134 0.29119,-2.91189 -0.58238,2.52364 z m -3.97959,-29.79837 -10.19163,-2.52365 -1.74714,-0.48531 -1.65007,-0.38825 v 0 l -4.07665,9.02687 1.74714,2.13539 -0.0971,6.50322 1.8442,0.29119 3.78546,9.90044 -0.19412,0.29119 -4.75609,6.98855 0.48531,5.33847 11.45345,3.88252 0.0971,4.46491 2.62071,-3.6884 0.38825,-5.33847 2.71777,-1.8442 -1.0677,-3.97959 2.03833,-4.75609 V 168.0163 l -0.67944,-3.39721 -4.56197,0.0971 1.16476,-4.65903 0.67944,-7.47386 v 0 z",
    "data-id": "NJ",
    "data-name": "New Jersey",
    id: "NJ"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#68c95e",
      fillRule: "evenodd",
      strokeWidth: 0.97063118
    },
    d: "m 763.69263,160.44538 -1.45595,2.03832 -0.38825,0.58238 z m 13.39471,-4.75609 4.85316,-4.27078 v -0.19413 z m -12.71527,3.00895 v -3.30014 l -0.29119,1.74713 z m 22.51864,-15.5301 -1.16475,-0.29119 -0.19413,0.87357 z m 2.62071,-1.74713 -0.0971,0.97063 0.19412,-0.58238 -0.0971,-0.38825 z m -2.71777,0.0971 -6.50323,6.01791 -9.9975,4.27078 -2.6207,2.23245 -0.19413,2.13539 -2.71777,2.23245 0.38826,2.9119 4.17371,-1.65008 6.11498,-4.95022 6.79441,-3.59133 10.2887,-9.70631 -7.27974,5.53259 -2.32951,0.97064 z m 3.00896,-4.07665 0.38825,-0.58238 -1.16476,1.35888 z m -109.09895,-3.59134 -1.55301,-0.19412 1.16476,1.55301 z m 32.22496,-29.70131 0.19412,-1.0677 -0.7765,0.97064 0.58238,0.0971 z m 0.48531,-6.988555 -0.38825,0.19413 -0.48532,1.06769 z m -41.0577,55.131865 0.67944,2.91189 5.14435,1.26182 29.50719,-8.05624 29.70131,-8.92981 5.43554,4.17372 1.06769,2.42658 6.3091,2.71776 0.19413,0.38826 1.65007,0.38825 1.74714,0.48531 10.19163,2.52365 -0.19413,-0.48532 0.87357,3.97959 1.94126,-0.48532 1.0677,-4.36784 v -0.0971 l -1.74714,-1.65007 2.52364,-3.10602 -1.16476,-1.45595 -3.68839,-14.26828 -0.19413,-0.97063 -0.48532,-0.29119 -0.29119,-4.27078 -0.29119,-4.65903 -0.29118,-5.04728 v -0.29119 l -0.19413,0.0971 -4.85316,-15.918355 -5.14434,-8.05624 -1.45595,-9.60924 -4.36784,-10.191633 -0.58238,0.29119 -20.28619,6.794418 -4.07665,4.367845 -4.56197,8.73568 0.19413,1.94126 -6.01791,9.123935 3.68839,1.26182 1.0677,6.89148 -4.27078,5.62967 -12.81233,7.76504 -2.42658,-0.97063 -9.51218,1.35889 -8.83275,5.33847 0.48532,2.81483 3.10602,2.71777 -1.74714,8.54155 -6.98854,8.1533 -0.0971,0.0971 z",
    "data-id": "NY",
    "data-name": "New York",
    id: "NY"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#c6c627",
      fillRule: "evenodd",
      strokeWidth: 0.97063118
    },
    d: "m 750.20085,148.7978 -6.3091,-2.71776 -1.06769,-2.42658 -5.43554,-4.17372 -29.70131,8.92981 -29.50719,8.05624 -5.14435,-1.26182 -0.67944,-2.91189 -1.65007,1.26182 -2.6207,1.8442 -4.7561,4.85315 -0.58238,0.48532 2.71777,11.93876 0.48532,2.13539 2.42657,10.48282 0.48532,2.03832 v 0 l 4.27078,18.442 13.78296,-3.39721 1.94126,-0.48532 1.74714,-0.48531 6.89148,-1.8442 37.95168,-10.57988 6.89148,-2.13539 1.65008,-0.48532 v 0 l 0.7765,-1.94126 1.74714,-1.35888 h 2.32951 l 0.29119,-0.87357 3.78546,-4.27078 0.38825,-0.67944 0.29119,-0.19413 -3.78546,-9.90044 -1.8442,-0.29119 0.0971,-6.50322 -1.74714,-2.13539 4.07665,-9.02687 v 0 l -0.19413,-0.38826 z",
    "data-id": "PA",
    "data-name": "Pennsylvania",
    id: "PA"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#68c95e",
      fillRule: "evenodd",
      strokeWidth: 0.97063118
    },
    d: "m 796.98528,97.063155 h -0.0971 l 0.19412,0.0971 -0.0971,-0.0971 z m 7.18267,-20.674443 -0.77651,-1.164758 v 0.582379 z m -1.35888,-1.067695 v -0.970631 l -0.0971,-0.582379 z m 3.49427,-4.076651 -0.19413,-0.09706 0.0971,0.291189 0.0971,-0.194126 z m 9.70631,-4.853156 -0.19413,-1.455947 -0.38825,0.679442 z m -2.42658,0.582379 0.0971,-1.067694 -1.16476,0.194126 1.06769,0.873568 z m 3.59134,-3.203083 h -0.38825 v 0.194126 z m -4.85316,1.455947 -0.87357,-0.194126 -0.0971,0.873568 0.97063,-0.679442 z m 4.95022,-3.008957 0.87357,0.679442 -0.29119,-0.776505 -0.58238,0.09706 z m -2.6207,0.09706 -0.87357,1.650073 1.16476,-0.582379 z m -4.17372,0.09706 -0.38825,0.582379 0.29119,0.873568 0.0971,-1.455947 z m 5.72673,-3.203083 -0.0971,-0.776505 -0.29119,0.485316 0.38826,0.291189 z m -0.48532,0.388253 -0.87357,-0.776505 v 0.679442 l 0.87357,0.09706 z m -5.43553,2.232452 -0.19413,-1.067695 -0.38825,0.873568 z m 9.22099,-3.39721 -1.45594,2.135389 -0.0971,-1.55301 1.55301,-0.582379 z m 7.08561,-6.503229 -0.67944,-0.970631 -0.38825,0.194126 z m 2.6207,-4.36784 -0.58237,-0.291189 -0.0971,0.291189 h 0.67944 z m 1.26183,-7.570923 h -0.87357 l 0.97063,0.291189 -0.0971,-0.291189 z m 1.45594,0.970631 -0.29119,-1.747136 -0.7765,-0.09706 1.06769,1.8442 z m -1.55301,-1.55301 -0.19412,-1.844199 -0.67945,1.26182 z m -56.29661,15.23891 14.07415,33.001458 0.19413,0.67944 6.11498,7.47386 v -0.0971 l 0.97063,-0.29119 0.19413,-5.5326 1.55301,-1.94126 0.97063,-5.14435 -0.87357,-0.87357 1.65007,-5.047274 5.62966,-2.620704 3.6884,-4.464904 1.35888,-7.765049 5.92085,-0.388253 -0.7765,-3.979588 7.3768,-2.81483 0.48531,-4.36784 1.74714,0.388252 4.85315,-3.979588 2.13539,-5.144345 -4.95022,-4.950219 -5.2414,-1.067695 -1.94127,-3.979588 v -2.329515 l -3.20308,0.970632 -3.59134,-1.261821 V 25.139338 L 802.712,4.1737041 l -7.0856,-3.688398 -7.86212,6.600292 -2.13539,-0.388253 -1.8442,-3.397209 -2.52364,0.970631 -3.59133,17.8596139 1.26182,5.823788 1.06769,11.8417 -2.81483,9.123934 1.94126,1.455946 -2.32951,4.464904 -2.52364,-0.388253 -0.19413,0.194127 z",
    "data-id": "ME",
    "data-name": "Maine",
    id: "ME"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#c6c627",
      fillRule: "evenodd",
      strokeWidth: 0.97063118
    },
    d: "m 570.14877,116.86404 -0.48532,-0.77651 -0.0971,0.97063 0.58238,-0.19412 z m 1.55301,-1.74714 -1.16476,-1.55301 -0.19413,0.67944 z m 0.97063,-6.98854 -0.97063,-0.87357 v 0.19412 z m -2.42658,76.00042 12.03583,-1.94126 3.39721,-0.67944 14.85065,-2.62071 0.29119,1.26182 0.97063,-0.29119 6.40617,-1.35888 6.11498,-1.45595 6.21204,-1.55301 -0.0971,-0.29119 3.20309,-6.3091 -0.29119,-5.24141 3.59133,-9.02687 2.81483,1.65007 1.0677,-2.03832 -0.29119,-7.76505 -2.62071,-4.85316 -3.88252,-10.28869 -3.39721,-3.78546 -1.74714,-0.48531 -6.3091,4.36784 0.67944,0.87356 -3.30014,6.21204 -3.20309,-0.58238 -0.97063,-6.50322 1.35889,-0.48532 2.81483,-6.50323 0.29119,-11.45345 -4.36784,-9.70631 -9.70632,-1.65007 -0.97063,-1.45595 -9.02687,-2.620705 -4.07665,5.047285 0.38825,4.36784 -3.10602,3.88252 0.67945,6.01792 -3.00896,2.13539 v -7.57093 l -2.71777,5.72673 -3.20308,5.04728 -2.13539,1.65007 1.06769,5.33847 -1.35888,5.5326 0.77651,6.89148 -0.97064,3.39721 6.98855,13.39471 0.87357,5.14435 -0.87357,9.51218 -4.65903,10.67695 -0.58238,0.38825 z m 20.77151,-87.453875 -2.52364,0.19412 1.55301,1.16476 z m -14.7536,2.52364 h -0.7765 l 0.87357,0.38825 -0.0971,-0.38825 z m 16.98605,-12.32702 -0.97063,-1.55301 -0.38825,0.0971 1.35888,1.45594 z m -87.93919,7.08561 3.10602,1.74714 15.91835,4.853155 7.3768,1.94127 7.18267,0.48531 5.24141,4.27078 v 6.60029 l 4.65903,4.65903 v -0.0971 l 3.78546,-10.96814 4.56197,-3.20308 3.49427,-3.88252 0.58238,3.49427 3.59134,-5.532605 8.63861,-3.30014 0.67945,-1.35889 8.73568,1.0677 3.39721,1.74713 1.65007,-4.27077 1.55301,0.97063 6.79442,-1.0677 -1.65008,-2.71777 -3.00895,-1.74713 0.58238,-6.3091 -5.92085,3.30014 -5.43554,-0.67944 -1.74714,-4.17371 0.58238,-1.358888 -7.37679,3.494268 -4.7561,0.29119 -8.54155,5.24141 -0.97063,1.94126 -5.24141,-1.26182 -3.30015,1.45595 -6.60029,-5.72672 -14.65653,-4.46491 -0.29119,-1.747133 -9.41512,9.026873 -5.33847,1.35888 -7.57093,5.72673 -0.29119,0.19412 z m 34.36035,-22.033327 -11.35639,5.629661 3.78546,3.688396 1.45595,-3.688396 3.88253,-4.756093 z m -12.71527,-13.297647 -7.76505,5.338471 -0.38825,2.620704 6.11497,-4.464903 z",
    "data-id": "MI",
    "data-name": "Michigan",
    id: "MI"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#cb1d1d",
      fillRule: "evenodd",
      strokeWidth: 0.97063118
    },
    d: "m 12.909395,527.63524 -0.67945,-0.19412 0.48532,0.38825 z m 1.35888,0.0971 -1.0677,-0.29118 -0.19412,0.0971 1.26182,0.19412 z m 0.7765,-0.38825 -0.0971,-0.19412 -0.38825,0.0971 0.48531,0.0971 z m -2.91189,-1.16476 -0.38825,-0.19412 v 1.06769 z m 12.42408,2.42658 -0.0971,-0.0971 h -0.19413 l 0.29119,0.0971 z m 0.19413,-0.0971 v -0.0971 l -0.19413,-0.0971 0.19413,0.19413 z m -1.65008,-0.58238 0.19413,0.38825 v -0.0971 l -0.19413,-0.29119 z m 0.87357,0 -0.87357,-0.29119 1.0677,0.77651 z m 1.26182,-0.97063 v 0 0.0971 z m 11.55051,1.45595 -0.19412,-0.38826 h -0.0971 l 0.29119,0.38826 z m 104.439925,-6.50323 -0.19413,-0.19413 0.0971,0.19413 h 0.0971 z m -117.640505,3.00895 v -0.0971 l -0.0971,0.0971 z m 120.455335,-4.75609 0.29119,0.38825 h 0.19413 z m -106.089995,7.27974 -0.0971,0.0971 v 0.29119 l 0.0971,-0.38825 z m -12.03583,-1.74714 0.19413,-0.77651 h -0.0971 l -0.0971,0.77651 z m 123.755485,-7.76505 -0.87357,0.48532 0.77651,0.38825 0.0971,-0.87357 z m -122.008345,7.27973 -0.0971,-0.19412 z m -7.27973,-2.13539 -2.42658,0.48532 -2.13539,2.81483 z m 17.37429,3.6884 -0.58237,0.48532 0.58237,-0.0971 v -0.38826 z m 111.913785,-9.31806 -0.19412,-0.38825 -0.0971,0.19413 0.29119,0.19412 z m -121.231845,6.79442 -0.67944,-0.0971 0.67944,0.67944 v -0.58238 z m 114.825685,-5.5326 -0.19413,0.19413 0.19413,0.67944 z m -113.272675,5.43554 -0.29118,0.0971 0.38825,0.29119 -0.0971,-0.38825 z m 7.18268,2.03832 h -0.29119 l -0.19413,-0.19412 z m -7.95918,-2.03832 -0.48532,-0.29119 0.19413,0.29119 z m 6.50323,1.06769 -0.87357,0.29119 -0.58238,1.55301 z m 105.410555,-6.79441 v 0.67944 l 0.38825,-0.48532 z m -116.864005,3.68839 0.77651,-0.19412 h -0.0971 l -0.67944,0.19412 z m -0.97063,-0.58238 -0.19413,-0.19412 v 0.0971 l 0.19413,0.0971 z m 117.834635,-3.78546 -0.19413,-0.0971 -0.0971,0.29119 0.29119,-0.19413 z m -106.478255,5.82379 -0.19412,-0.0971 -0.19413,0.29119 0.38825,-0.19413 z m 105.507625,-5.62966 0.0971,-0.48532 -0.19413,-0.0971 0.0971,0.58238 z m -0.77651,-0.48532 -0.29119,0.38826 0.48532,0.0971 -0.19413,-0.48532 z m -100.654455,4.7561 -0.19413,-0.19413 h -0.0971 l 0.29119,0.19413 z m 100.363265,-6.50323 0.77651,0.29119 0.29119,-0.38826 -1.0677,0.0971 z m 1.16476,-0.67944 -0.29119,0.19412 0.48532,0.29119 z m -2.23245,0.58237 -0.19413,-0.38825 -0.19413,0.19413 z m 9.70631,-3.59133 -1.26182,3.59133 1.26182,-0.7765 z m -115.019805,7.47386 h -0.0971 v 0 z m 106.478245,-6.11498 -0.87356,0.87357 0.19412,0.97063 z m -90.365765,7.76505 v -0.38825 l -0.0971,0.19413 z m 89.298075,-8.73568 2.81483,4.27078 6.3091,3.97959 -1.45594,-3.39721 -6.01792,-5.14435 z m -93.180595,7.18267 -0.0971,-0.29119 -0.19412,0.0971 0.29119,0.19412 z m 96.480745,-8.83274 -0.38826,1.45595 0.67945,-0.48532 z m 2.03832,0 -0.0971,0.97063 0.87357,0.29119 -0.77651,-1.26182 z m -95.413055,7.57092 -0.48531,-0.0971 -0.48532,0.19413 0.97063,-0.0971 z m 9.99751,0.77651 -0.38826,0.67944 0.19413,-0.58238 0.19413,-0.0971 z m 1.45594,0.0971 -0.87357,0.0971 0.48532,0.58238 0.38825,-0.67944 z m -20.28619,-2.81483 0.0971,-0.0971 z m 0.29119,-0.0971 h 0.0971 v -0.0971 z m 100.363275,-7.47386 0.48531,1.8442 0.97063,-0.58238 z m -97.742575,6.40616 0.0971,-0.0971 v 0 z m 93.568855,-5.62966 0.48532,4.4649 0.97063,-0.97063 z m 0.48532,-1.45595 2.23245,3.10602 -0.29119,-2.03832 z m -6.89148,0.77651 -0.58238,1.8442 0.7765,-1.26182 z m -77.650505,4.75609 -0.0971,-0.0971 z m 9.221,0.19413 -0.19413,-0.29119 0.19413,0.38825 v -0.0971 z m 68.623625,-6.40617 3.88253,6.40617 -0.58238,-4.36784 z m -63.188095,3.39721 -0.29119,0.29119 0.48532,0.19413 z m -1.26182,0.19413 0.0971,-0.29119 h -0.38825 l 0.29119,0.29119 z m -0.97063,0 -2.52364,1.65007 -3.10602,4.07665 1.55301,1.65008 7.18267,-5.33848 z m 61.246835,-6.3091 -0.67944,-0.38826 v 0.58238 z m -61.829215,5.14434 0.0971,0.38825 0.67945,0.38826 -0.77651,-0.77651 z m 63.673415,-6.98854 -1.94126,0.97063 1.84419,0.58238 0.0971,-1.55301 z m -1.26182,0 -0.19413,-0.19413 -0.0971,0.19413 h 0.29119 z m 5.92085,-1.55301 -0.77651,-0.29119 -0.19412,0.58238 z m -4.17372,0.67944 -0.67944,-0.0971 v 0.19413 l 0.67944,-0.0971 z m 2.13539,-0.77651 3.97959,5.82379 -1.06769,-5.33847 z m -64.061665,6.30911 -2.32951,1.74713 1.06769,1.16476 3.10602,-2.32952 z m -26.40117,-3.6884 -0.0971,-0.0971 v 0.0971 z m -1.06769,-0.48532 -0.0971,-0.48531 v 0.19412 z m 29.79838,1.26182 -0.19413,0.0971 v 0.0971 l 0.19413,-0.19413 z m -0.97063,-0.19412 h -0.0971 l -0.19412,0.29119 0.29119,-0.29119 z m 2.32951,-0.77651 -0.29119,-0.19413 v 0.0971 l 0.29119,0.0971 z m 0.77651,-0.0971 -0.29119,-0.19413 v 0.0971 l 0.29119,0.0971 z m -1.26182,-0.29119 h -0.38826 v 0.0971 z m 19.31556,-1.94126 0.0971,-0.29119 -0.19413,0.19412 0.0971,0.0971 z m 5.92085,-3.10602 1.16475,-1.45595 -0.38825,0.29119 z m -11.8417,-0.19413 0.38825,-0.29119 0.0971,-0.38825 -0.48531,0.67944 z m 0,-1.06769 -0.38826,0.29118 0.67945,-0.19412 -0.29119,-0.0971 z m -15.91836,0 -0.0971,-0.38826 h -0.0971 l 0.19412,0.38826 z m 15.5301,-0.0971 -0.38825,0.38825 -0.19412,0.38826 z m 10.67695,-1.16476 h 0.0971 0.0971 -0.19412 z m 0.48531,0 -0.19412,-0.0971 v 0.0971 z m -1.16475,-0.0971 0.0971,0.0971 v -0.0971 z m -7.95918,0.58238 0.38825,-0.38825 -0.48531,0.38825 h 0.0971 z m 1.16476,-0.87357 -2.32952,3.78546 3.00896,-3.49427 z m -3.00896,0.48532 -0.29119,-0.38825 -0.0971,0.19412 0.38825,0.19413 z m 7.3768,-0.87357 -0.19413,-0.0971 0.0971,0.0971 h 0.0971 z m 2.52364,0.19413 v -0.67945 l -0.19413,0.29119 z m -71.24433,-7.47386 -4.65903,-0.19413 3.20308,3.39721 z m 66.29411,6.89148 0.19413,0.67944 0.48531,-0.77651 -0.67944,0.0971 z m -3.88253,-0.0971 -0.29119,2.13539 0.48532,-1.35888 z m -0.97063,-1.35888 0.0971,0.29119 0.19412,-0.0971 -0.29119,-0.19413 z m -0.48531,0.38825 -0.19413,-0.58238 -0.29119,0.19413 z m 4.56196,-1.16475 v -0.38826 l -0.29119,0.19413 z m -4.36784,-0.58238 v 0.97063 l 0.29119,-0.67944 z m -7.37679,-1.16476 v -0.29119 0 z m -50.66695,-12.03583 0.19412,-0.58238 -0.0971,0.0971 -0.0971,0.48531 z m 0.29119,-0.97063 -0.0971,-0.0971 -0.0971,0.0971 h 0.19413 z m 4.27077,-2.32951 v -0.0971 0 z m 0,-0.38826 -0.0971,-0.19412 v 0 z m 1.74714,-2.52364 v 0 h -0.0971 z m 0.58238,0.19413 -0.38825,-0.19413 v 0.0971 l 0.38825,0.0971 z m -0.58238,-0.38825 v -0.19413 l -0.19413,0.19413 z m -15.5301,-4.56197 -0.19412,-0.48532 -0.0971,-0.29118 0.29119,0.7765 z m 1.45595,-1.74714 h 0.0971 l 0.0971,0.0971 -0.19412,-0.0971 z m -2.62071,-0.48531 -0.7765,-0.97063 0.58238,0.7765 z m -1.55301,-1.55301 h -0.19412 l 0.29119,0.0971 -0.0971,-0.0971 z m 0,-1.1648 v 0 l 0.19413,0.0971 z m 25.72173,7.66799 -1.06769,0.0971 0.58238,0.29119 0.48531,-0.38825 z m -26.78942,-9.41513 -0.77651,2.9119 2.42658,0.38825 3.20309,3.30015 1.94126,-0.87357 z m 16.98605,1.16476 v -0.19412 0.0971 0.0971 z m -4.85316,-10.28869 -0.19413,-0.0971 0.0971,0.0971 h 0.0971 z m 2.81483,0.97063 0.29119,-0.0971 h -0.0971 l -0.19413,0.0971 z m 1.94126,-0.58238 h 0.29119 l 0.87357,-0.38825 z m 3.49428,-1.06769 0.19412,-0.19413 -0.29119,0.19413 h 0.0971 z m 0.48531,-0.0971 0.58238,-0.29119 -0.48532,0.0971 -0.0971,0.19413 z m 1.45595,-0.58238 -0.48532,0.0971 v 0.0971 l 0.48532,-0.19412 z m 62.31452,-17.56846 -0.38825,-0.29119 -0.67944,-0.29119 z m -50.86107,-2.13539 0.87356,-1.16475 -0.48531,0.38825 z m 1.16475,-1.35888 0.38826,-0.58238 -0.19413,0.19413 z m 0.58238,-0.7765 0.67944,-0.58238 -0.38825,0.19412 z m 30.57488,0.19412 0.48532,0.48532 h 0.29119 z m -15.62716,-6.40616 -3.97959,3.30014 -2.42657,-0.67944 -5.62966,3.20308 -1.0677,-0.67944 -6.40616,7.18267 -6.50323,1.45595 0.58237,3.49427 2.9119,3.97959 5.43553,5.24141 -0.87356,2.03832 4.07665,1.74714 -2.13539,0.38825 -2.62071,-2.03832 1.35889,3.00895 -1.74714,1.0677 -5.5326,-5.04728 -4.36784,0.7765 -7.47386,2.81483 3.39721,3.78546 -0.48531,2.32952 2.23245,2.71776 7.37679,2.9119 5.33848,-2.71777 0.87356,2.03833 -1.45594,6.11497 h -4.46491 l -5.2414,2.32952 -0.29119,-1.65008 -2.71777,1.0677 -1.26182,2.81483 -4.46491,3.39721 v 4.95022 l 1.74714,0.7765 -1.35888,4.17372 5.82378,5.04728 3.6884,-1.55301 -0.7765,6.21204 1.06769,1.35888 4.46491,0.97063 1.65007,1.8442 3.88252,0.29119 1.8442,1.94127 3.97959,-1.16476 -1.8442,2.52364 -1.45595,5.14434 -11.8417,7.66799 -1.55301,1.55301 -2.23245,-0.87357 -3.59133,0.87357 -5.14435,3.39721 8.05624,-2.32952 1.16476,1.74714 10.38575,-3.39721 0.29119,1.35889 4.07665,-4.07666 8.54156,-5.92085 0.67944,0.38826 7.47386,-5.92085 -1.94126,-2.32952 2.52364,-4.17371 6.60029,-7.86212 5.04728,-0.97063 1.55301,1.0677 -6.11497,1.74713 -1.65008,6.50323 0.19413,3.49428 2.13539,-0.19413 10.28869,-6.21204 0.7765,-2.32952 -0.87356,-3.59133 3.10601,0.7765 2.23246,-1.45594 6.40616,3.88252 -0.48531,1.0677 14.559465,1.8442 3.39721,-1.0677 0.97064,1.45595 12.6182,6.01791 2.13539,-1.26182 0.19413,-7.27973 1.65007,3.30014 8.1533,5.92085 0.67944,2.42658 7.08561,3.97959 1.8442,5.14434 1.74714,-3.97958 3.59133,6.98854 2.42658,-3.97959 -1.94126,-4.95022 -7.47386,-0.7765 -11.45345,-10.96813 -6.21204,-4.56197 -4.75609,4.65903 h -2.81483 l -6.50323,-4.27078 -6.40617,-0.29119 -9.123935,-57.55843 -1.55301,-2.71776 -3.6884,-2.23246 -5.5326,1.0677 -4.27078,-0.87357 -5.43553,-2.13539 -5.72673,0.38825 -1.45594,-2.71776 -4.56197,-0.67945 -0.7765,-1.65007 -2.03833,2.32952 z",
    "data-id": "AK",
    "data-name": "Alaska",
    id: "AK"
  }), /*#__PURE__*/React.createElement("text", {
    pointerEvents: "none",
    id: "text124",
    y: 58.349159,
    x: 81.355194,
    style: {
      fontStyle: "normal",
      fontWeight: "normal",
      fontSize: 40,
      lineHeight: 1.25,
      fontFamily: "sans-serif",
      letterSpacing: 0,
      wordSpacing: 0,
      fill: "#000000",
      fillOpacity: 1,
      stroke: "none"
    },
    xmlSpace: "preserve"
  }, /*#__PURE__*/React.createElement("tspan", {
    style: {
      fontSize: 16
    },
    y: 58.349159,
    x: 81.355194,
    id: "tspan122"
  }, "WA")), /*#__PURE__*/React.createElement("text", {
    pointerEvents: "none",
    id: "text124-9-0",
    y: 124.7394,
    x: 55.417156,
    style: {
      fontStyle: "normal",
      fontWeight: "normal",
      fontSize: 40,
      lineHeight: 1.25,
      fontFamily: "sans-serif",
      letterSpacing: 0,
      wordSpacing: 0,
      fill: "#000000",
      fillOpacity: 1,
      stroke: "none",
      strokeLinejoin: "round"
    },
    xmlSpace: "preserve"
  }, /*#__PURE__*/React.createElement("tspan", {
    id: "tspan164-1",
    style: {
      fontSize: 16
    },
    y: 124.7394,
    x: 55.417156
  }, "OR")), /*#__PURE__*/React.createElement("text", {
    pointerEvents: "none",
    id: "text124-9-3",
    y: 286.6817,
    x: 46.763744,
    style: {
      fontStyle: "normal",
      fontWeight: "normal",
      fontSize: 40,
      lineHeight: 1.25,
      fontFamily: "sans-serif",
      letterSpacing: 0,
      wordSpacing: 0,
      fill: "#000000",
      fillOpacity: 1,
      stroke: "none",
      strokeLinejoin: "round"
    },
    xmlSpace: "preserve"
  }, /*#__PURE__*/React.createElement("tspan", {
    id: "tspan164-7",
    style: {
      fontSize: 16
    },
    y: 286.6817,
    x: 46.763744
  }, "CA")), /*#__PURE__*/React.createElement("text", {
    pointerEvents: "none",
    id: "text124-9-1",
    y: 222.39925,
    x: 93.73938,
    style: {
      fontStyle: "normal",
      fontWeight: "normal",
      fontSize: 40,
      lineHeight: 1.25,
      fontFamily: "sans-serif",
      letterSpacing: 0,
      wordSpacing: 0,
      fill: "#000000",
      fillOpacity: 1,
      stroke: "none",
      strokeLinejoin: "round"
    },
    xmlSpace: "preserve"
  }, /*#__PURE__*/React.createElement("tspan", {
    id: "tspan164-3",
    style: {
      fontSize: 16
    },
    y: 222.39925,
    x: 93.73938
  }, "NV")), /*#__PURE__*/React.createElement("text", {
    pointerEvents: "none",
    id: "text124-9-6",
    y: 146.99101,
    x: 144.4236,
    style: {
      fontStyle: "normal",
      fontWeight: "normal",
      fontSize: 40,
      lineHeight: 1.25,
      fontFamily: "sans-serif",
      letterSpacing: 0,
      wordSpacing: 0,
      fill: "#000000",
      fillOpacity: 1,
      stroke: "none",
      strokeLinejoin: "round"
    },
    xmlSpace: "preserve"
  }, /*#__PURE__*/React.createElement("tspan", {
    id: "tspan164-32",
    style: {
      fontSize: 16
    },
    y: 146.99101,
    x: 144.4236
  }, "ID")), /*#__PURE__*/React.createElement("text", {
    pointerEvents: "none",
    id: "text124-9-8",
    y: 85.180977,
    x: 226.01286,
    style: {
      fontStyle: "normal",
      fontWeight: "normal",
      fontSize: 40,
      lineHeight: 1.25,
      fontFamily: "sans-serif",
      letterSpacing: 0,
      wordSpacing: 0,
      fill: "#000000",
      fillOpacity: 1,
      stroke: "none",
      strokeLinejoin: "round"
    },
    xmlSpace: "preserve"
  }, /*#__PURE__*/React.createElement("tspan", {
    id: "tspan164-77",
    style: {
      fontSize: 16
    },
    y: 85.180977,
    x: 226.01286
  }, "MT")), /*#__PURE__*/React.createElement("text", {
    pointerEvents: "none",
    id: "text124-9-87",
    y: 176.65982,
    x: 245.79207,
    style: {
      fontStyle: "normal",
      fontWeight: "normal",
      fontSize: 40,
      lineHeight: 1.25,
      fontFamily: "sans-serif",
      letterSpacing: 0,
      wordSpacing: 0,
      fill: "#000000",
      fillOpacity: 1,
      stroke: "none",
      strokeLinejoin: "round"
    },
    xmlSpace: "preserve"
  }, /*#__PURE__*/React.createElement("tspan", {
    id: "tspan164-0",
    style: {
      fontSize: 16
    },
    y: 176.65982,
    x: 245.79207
  }, "WY")), /*#__PURE__*/React.createElement("text", {
    pointerEvents: "none",
    id: "text124-9-4",
    y: 87.653381,
    x: 347.16049,
    style: {
      fontStyle: "normal",
      fontWeight: "normal",
      fontSize: 40,
      lineHeight: 1.25,
      fontFamily: "sans-serif",
      letterSpacing: 0,
      wordSpacing: 0,
      fill: "#000000",
      fillOpacity: 1,
      stroke: "none",
      strokeLinejoin: "round"
    },
    xmlSpace: "preserve"
  }, /*#__PURE__*/React.createElement("tspan", {
    id: "tspan164-4",
    style: {
      fontSize: 16
    },
    y: 87.653381,
    x: 347.16049
  }, "ND")), /*#__PURE__*/React.createElement("text", {
    pointerEvents: "none",
    id: "text124-9-11",
    y: 151.93581,
    x: 348.3967,
    style: {
      fontStyle: "normal",
      fontWeight: "normal",
      fontSize: 40,
      lineHeight: 1.25,
      fontFamily: "sans-serif",
      letterSpacing: 0,
      wordSpacing: 0,
      fill: "#000000",
      fillOpacity: 1,
      stroke: "none",
      strokeLinejoin: "round"
    },
    xmlSpace: "preserve"
  }, /*#__PURE__*/React.createElement("tspan", {
    id: "tspan164-12",
    style: {
      fontSize: 16
    },
    y: 151.93581,
    x: 348.3967
  }, "SD")), /*#__PURE__*/React.createElement("text", {
    pointerEvents: "none",
    id: "text124-9-08",
    y: 106.19638,
    x: 433.69449,
    style: {
      fontStyle: "normal",
      fontWeight: "normal",
      fontSize: 40,
      lineHeight: 1.25,
      fontFamily: "sans-serif",
      letterSpacing: 0,
      wordSpacing: 0,
      fill: "#000000",
      fillOpacity: 1,
      stroke: "none",
      strokeLinejoin: "round"
    },
    xmlSpace: "preserve"
  }, /*#__PURE__*/React.createElement("tspan", {
    id: "tspan164-31",
    style: {
      fontSize: 16
    },
    y: 106.19638,
    x: 433.69449
  }, "MN")), /*#__PURE__*/React.createElement("text", {
    pointerEvents: "none",
    id: "text124-9-69",
    y: 137.10141,
    x: 497.97696,
    style: {
      fontStyle: "normal",
      fontWeight: "normal",
      fontSize: 40,
      lineHeight: 1.25,
      fontFamily: "sans-serif",
      letterSpacing: 0,
      wordSpacing: 0,
      fill: "#000000",
      fillOpacity: 1,
      stroke: "none",
      strokeLinejoin: "round"
    },
    xmlSpace: "preserve"
  }, /*#__PURE__*/React.createElement("tspan", {
    id: "tspan164-47",
    style: {
      fontSize: 16
    },
    y: 137.10141,
    x: 497.97696
  }, "WI")), /*#__PURE__*/React.createElement("text", {
    pointerEvents: "none",
    id: "text124-9-13",
    y: 154.40822,
    x: 583.27484,
    style: {
      fontStyle: "normal",
      fontWeight: "normal",
      fontSize: 40,
      lineHeight: 1.25,
      fontFamily: "sans-serif",
      letterSpacing: 0,
      wordSpacing: 0,
      fill: "#000000",
      fillOpacity: 1,
      stroke: "none",
      strokeLinejoin: "round"
    },
    xmlSpace: "preserve"
  }, /*#__PURE__*/React.createElement("tspan", {
    id: "tspan164-05",
    style: {
      fontSize: 16
    },
    y: 154.40822,
    x: 583.27484
  }, "MI")), /*#__PURE__*/React.createElement("text", {
    pointerEvents: "none",
    id: "text124-9-2",
    y: 229.81645,
    x: 570.91284,
    style: {
      fontStyle: "normal",
      fontWeight: "normal",
      fontSize: 40,
      lineHeight: 1.25,
      fontFamily: "sans-serif",
      letterSpacing: 0,
      wordSpacing: 0,
      fill: "#000000",
      fillOpacity: 1,
      stroke: "none",
      strokeLinejoin: "round"
    },
    xmlSpace: "preserve"
  }, /*#__PURE__*/React.createElement("tspan", {
    id: "tspan164-70",
    style: {
      fontSize: 16
    },
    y: 229.81645,
    x: 570.91284
  }, "IN")), /*#__PURE__*/React.createElement("text", {
    pointerEvents: "none",
    id: "text124-9-00",
    y: 202.62004,
    x: 616.65222,
    style: {
      fontStyle: "normal",
      fontWeight: "normal",
      fontSize: 40,
      lineHeight: 1.25,
      fontFamily: "sans-serif",
      letterSpacing: 0,
      wordSpacing: 0,
      fill: "#000000",
      fillOpacity: 1,
      stroke: "none",
      strokeLinejoin: "round"
    },
    xmlSpace: "preserve"
  }, /*#__PURE__*/React.createElement("tspan", {
    id: "tspan164-42",
    style: {
      fontSize: 16
    },
    y: 202.62004,
    x: 616.65222
  }, "OH")), /*#__PURE__*/React.createElement("text", {
    pointerEvents: "none",
    id: "text124-9-15",
    y: 169.24263,
    x: 694.5329,
    style: {
      fontStyle: "normal",
      fontWeight: "normal",
      fontSize: 40,
      lineHeight: 1.25,
      fontFamily: "sans-serif",
      letterSpacing: 0,
      wordSpacing: 0,
      fill: "#000000",
      fillOpacity: 1,
      stroke: "none",
      strokeLinejoin: "round"
    },
    xmlSpace: "preserve"
  }, /*#__PURE__*/React.createElement("tspan", {
    id: "tspan164-36",
    style: {
      fontSize: 16
    },
    y: 169.24263,
    x: 694.5329
  }, "PA")), /*#__PURE__*/React.createElement("text", {
    pointerEvents: "none",
    id: "text124-9-86",
    y: 122.267,
    x: 724.20166,
    style: {
      fontStyle: "normal",
      fontWeight: "normal",
      fontSize: 40,
      lineHeight: 1.25,
      fontFamily: "sans-serif",
      letterSpacing: 0,
      wordSpacing: 0,
      fill: "#000000",
      fillOpacity: 1,
      stroke: "none",
      strokeLinejoin: "round"
    },
    xmlSpace: "preserve"
  }, /*#__PURE__*/React.createElement("tspan", {
    id: "tspan164-5",
    style: {
      fontSize: 16
    },
    y: 122.267,
    x: 724.20166
  }, "NY")), /*#__PURE__*/React.createElement("text", {
    pointerEvents: "none",
    id: "text124-9-07",
    y: 55.512161,
    x: 698.24146,
    style: {
      fontStyle: "normal",
      fontWeight: "normal",
      fontSize: 40,
      lineHeight: 1.25,
      fontFamily: "sans-serif",
      letterSpacing: 0,
      wordSpacing: 0,
      fill: "#000000",
      fillOpacity: 1,
      stroke: "none",
      strokeLinejoin: "round"
    },
    xmlSpace: "preserve"
  }, /*#__PURE__*/React.createElement("tspan", {
    id: "tspan164-19",
    style: {
      fontSize: 16
    },
    y: 55.512161,
    x: 698.24146
  }, "VT")), /*#__PURE__*/React.createElement("text", {
    pointerEvents: "none",
    id: "text124-9-46",
    y: 30.788149,
    x: 734.09131,
    style: {
      fontStyle: "normal",
      fontWeight: "normal",
      fontSize: 40,
      lineHeight: 1.25,
      fontFamily: "sans-serif",
      letterSpacing: 0,
      wordSpacing: 0,
      fill: "#000000",
      fillOpacity: 1,
      stroke: "none",
      strokeLinejoin: "round"
    },
    xmlSpace: "preserve"
  }, /*#__PURE__*/React.createElement("tspan", {
    id: "tspan164-2",
    style: {
      fontSize: 16
    },
    y: 30.788149,
    x: 734.09131
  }, "NH")), /*#__PURE__*/React.createElement("text", {
    pointerEvents: "none",
    id: "text124-9-9",
    y: 48.094955,
    x: 788.48413,
    style: {
      fontStyle: "normal",
      fontWeight: "normal",
      fontSize: 40,
      lineHeight: 1.25,
      fontFamily: "sans-serif",
      letterSpacing: 0,
      wordSpacing: 0,
      fill: "#000000",
      fillOpacity: 1,
      stroke: "none",
      strokeLinejoin: "round"
    },
    xmlSpace: "preserve"
  }, /*#__PURE__*/React.createElement("tspan", {
    id: "tspan164-6",
    style: {
      fontSize: 16
    },
    y: 48.094955,
    x: 788.48413
  }, "ME")), /*#__PURE__*/React.createElement("text", {
    pointerEvents: "none",
    id: "text124-9-5",
    y: 98.957825,
    x: 864.62079,
    style: {
      fontStyle: "normal",
      fontWeight: "normal",
      fontSize: 40,
      lineHeight: 1.25,
      fontFamily: "sans-serif",
      letterSpacing: 0,
      wordSpacing: 0,
      fill: "#000000",
      fillOpacity: 1,
      stroke: "none",
      strokeLinejoin: "round"
    },
    xmlSpace: "preserve"
  }, /*#__PURE__*/React.createElement("tspan", {
    id: "tspan164-11",
    style: {
      fontSize: 16
    },
    y: 98.957825,
    x: 864.62079
  }, "RI")), /*#__PURE__*/React.createElement("text", {
    pointerEvents: "none",
    id: "text124-9-80",
    y: 173.12987,
    x: 839.89667,
    style: {
      fontStyle: "normal",
      fontWeight: "normal",
      fontSize: 40,
      lineHeight: 1.25,
      fontFamily: "sans-serif",
      letterSpacing: 0,
      wordSpacing: 0,
      fill: "#000000",
      fillOpacity: 1,
      stroke: "none",
      strokeLinejoin: "round"
    },
    xmlSpace: "preserve"
  }, /*#__PURE__*/React.createElement("tspan", {
    id: "tspan164-22",
    style: {
      fontSize: 16
    },
    y: 173.12987,
    x: 839.89667
  }, "NJ")), /*#__PURE__*/React.createElement("text", {
    pointerEvents: "none",
    id: "text124-9-54",
    y: 253.30428,
    x: 808.26337,
    style: {
      fontStyle: "normal",
      fontWeight: "normal",
      fontSize: 40,
      lineHeight: 1.25,
      fontFamily: "sans-serif",
      letterSpacing: 0,
      wordSpacing: 0,
      fill: "#000000",
      fillOpacity: 1,
      stroke: "none",
      strokeLinejoin: "round"
    },
    xmlSpace: "preserve"
  }, /*#__PURE__*/React.createElement("tspan", {
    id: "tspan164-9",
    style: {
      fontSize: 16
    },
    y: 253.30428,
    x: 808.26337
  }, "MD")), /*#__PURE__*/React.createElement("text", {
    pointerEvents: "none",
    id: "text124-9-57",
    y: 213.74583,
    x: 811.97192,
    style: {
      fontStyle: "normal",
      fontWeight: "normal",
      fontSize: 40,
      lineHeight: 1.25,
      fontFamily: "sans-serif",
      letterSpacing: 0,
      wordSpacing: 0,
      fill: "#000000",
      fillOpacity: 1,
      stroke: "none",
      strokeLinejoin: "round"
    },
    xmlSpace: "preserve"
  }, /*#__PURE__*/React.createElement("tspan", {
    id: "tspan164-54",
    style: {
      fontSize: 16
    },
    y: 213.74583,
    x: 811.97192
  }, "DE")), /*#__PURE__*/React.createElement("text", {
    pointerEvents: "none",
    id: "text124-9-01",
    y: 139.75246,
    x: 849.78632,
    style: {
      fontStyle: "normal",
      fontWeight: "normal",
      fontSize: 40,
      lineHeight: 1.25,
      fontFamily: "sans-serif",
      letterSpacing: 0,
      wordSpacing: 0,
      fill: "#000000",
      fillOpacity: 1,
      stroke: "none",
      strokeLinejoin: "round"
    },
    xmlSpace: "preserve"
  }, /*#__PURE__*/React.createElement("tspan", {
    id: "tspan164-23",
    style: {
      fontSize: 16
    },
    y: 139.75246,
    x: 849.78632
  }, "CT")), /*#__PURE__*/React.createElement("text", {
    pointerEvents: "none",
    id: "text124-9-876",
    y: 281.73691,
    x: 792.19275,
    style: {
      fontStyle: "normal",
      fontWeight: "normal",
      fontSize: 40,
      lineHeight: 1.25,
      fontFamily: "sans-serif",
      letterSpacing: 0,
      wordSpacing: 0,
      fill: "#000000",
      fillOpacity: 1,
      stroke: "none",
      strokeLinejoin: "round"
    },
    xmlSpace: "preserve"
  }, /*#__PURE__*/React.createElement("tspan", {
    id: "tspan164-30",
    style: {
      fontSize: 16
    },
    y: 281.73691,
    x: 792.19275
  }, "DC")), /*#__PURE__*/React.createElement("text", {
    pointerEvents: "none",
    id: "text124-9-7",
    y: 287.91791,
    x: 697.00531,
    style: {
      fontStyle: "normal",
      fontWeight: "normal",
      fontSize: 40,
      lineHeight: 1.25,
      fontFamily: "sans-serif",
      letterSpacing: 0,
      wordSpacing: 0,
      fill: "#000000",
      fillOpacity: 1,
      stroke: "none",
      strokeLinejoin: "round"
    },
    xmlSpace: "preserve"
  }, /*#__PURE__*/React.createElement("tspan", {
    id: "tspan164-27",
    style: {
      fontSize: 16
    },
    y: 287.91791,
    x: 697.00531
  }, "NC")), /*#__PURE__*/React.createElement("text", {
    pointerEvents: "none",
    id: "text124-9-82",
    y: 326.24011,
    x: 678.46228,
    style: {
      fontStyle: "normal",
      fontWeight: "normal",
      fontSize: 40,
      lineHeight: 1.25,
      fontFamily: "sans-serif",
      letterSpacing: 0,
      wordSpacing: 0,
      fill: "#000000",
      fillOpacity: 1,
      stroke: "none",
      strokeLinejoin: "round"
    },
    xmlSpace: "preserve"
  }, /*#__PURE__*/React.createElement("tspan", {
    id: "tspan164-71",
    style: {
      fontSize: 16
    },
    y: 326.24011,
    x: 678.46228
  }, "SC")), /*#__PURE__*/React.createElement("text", {
    pointerEvents: "none",
    id: "text124-9-28",
    y: 360.85373,
    x: 642.61243,
    style: {
      fontStyle: "normal",
      fontWeight: "normal",
      fontSize: 40,
      lineHeight: 1.25,
      fontFamily: "sans-serif",
      letterSpacing: 0,
      wordSpacing: 0,
      fill: "#000000",
      fillOpacity: 1,
      stroke: "none",
      strokeLinejoin: "round"
    },
    xmlSpace: "preserve"
  }, /*#__PURE__*/React.createElement("tspan", {
    id: "tspan164-96",
    style: {
      fontSize: 16
    },
    y: 360.85373,
    x: 642.61243
  }, "GA")), /*#__PURE__*/React.createElement("text", {
    pointerEvents: "none",
    id: "text124-9-26",
    y: 453.56879,
    x: 697.00531,
    style: {
      fontStyle: "normal",
      fontWeight: "normal",
      fontSize: 40,
      lineHeight: 1.25,
      fontFamily: "sans-serif",
      letterSpacing: 0,
      wordSpacing: 0,
      fill: "#000000",
      fillOpacity: 1,
      stroke: "none",
      strokeLinejoin: "round"
    },
    xmlSpace: "preserve"
  }, /*#__PURE__*/React.createElement("tspan", {
    id: "tspan164-8",
    style: {
      fontSize: 16
    },
    y: 453.56879,
    x: 697.00531
  }, "FL")), /*#__PURE__*/React.createElement("text", {
    pointerEvents: "none",
    id: "text124-9-04",
    y: 374.45193,
    x: 577.09381,
    style: {
      fontStyle: "normal",
      fontWeight: "normal",
      fontSize: 40,
      lineHeight: 1.25,
      fontFamily: "sans-serif",
      letterSpacing: 0,
      wordSpacing: 0,
      fill: "#000000",
      fillOpacity: 1,
      stroke: "none",
      strokeLinejoin: "round"
    },
    xmlSpace: "preserve"
  }, /*#__PURE__*/React.createElement("tspan", {
    id: "tspan164-02",
    style: {
      fontSize: 16
    },
    y: 374.45193,
    x: 577.09381
  }, "AL")), /*#__PURE__*/React.createElement("text", {
    pointerEvents: "none",
    id: "text124-9-38",
    y: 370.74335,
    x: 531.35437,
    style: {
      fontStyle: "normal",
      fontWeight: "normal",
      fontSize: 40,
      lineHeight: 1.25,
      fontFamily: "sans-serif",
      letterSpacing: 0,
      wordSpacing: 0,
      fill: "#000000",
      fillOpacity: 1,
      stroke: "none",
      strokeLinejoin: "round"
    },
    xmlSpace: "preserve"
  }, /*#__PURE__*/React.createElement("tspan", {
    id: "tspan164-76",
    style: {
      fontSize: 16
    },
    y: 370.74335,
    x: 531.35437
  }, "MS")), /*#__PURE__*/React.createElement("text", {
    pointerEvents: "none",
    id: "text124-9-45",
    y: 305.2247,
    x: 589.45587,
    style: {
      fontStyle: "normal",
      fontWeight: "normal",
      fontSize: 40,
      lineHeight: 1.25,
      fontFamily: "sans-serif",
      letterSpacing: 0,
      wordSpacing: 0,
      fill: "#000000",
      fillOpacity: 1,
      stroke: "none",
      strokeLinejoin: "round"
    },
    xmlSpace: "preserve"
  }, /*#__PURE__*/React.createElement("tspan", {
    id: "tspan164-704",
    style: {
      fontSize: 16
    },
    y: 305.2247,
    x: 589.45587
  }, "TN")), /*#__PURE__*/React.createElement("text", {
    pointerEvents: "none",
    id: "text124-9-458",
    y: 268.13867,
    x: 603.05402,
    style: {
      fontStyle: "normal",
      fontWeight: "normal",
      fontSize: 40,
      lineHeight: 1.25,
      fontFamily: "sans-serif",
      letterSpacing: 0,
      wordSpacing: 0,
      fill: "#000000",
      fillOpacity: 1,
      stroke: "none",
      strokeLinejoin: "round"
    },
    xmlSpace: "preserve"
  }, /*#__PURE__*/React.createElement("tspan", {
    id: "tspan164-51",
    style: {
      fontSize: 16
    },
    y: 268.13867,
    x: 603.05402
  }, "KY")), /*#__PURE__*/React.createElement("text", {
    pointerEvents: "none",
    id: "text124-9-867",
    y: 274.3197,
    x: 470.78055,
    style: {
      fontStyle: "normal",
      fontWeight: "normal",
      fontSize: 40,
      lineHeight: 1.25,
      fontFamily: "sans-serif",
      letterSpacing: 0,
      wordSpacing: 0,
      fill: "#000000",
      fillOpacity: 1,
      stroke: "none",
      strokeLinejoin: "round"
    },
    xmlSpace: "preserve"
  }, /*#__PURE__*/React.createElement("tspan", {
    id: "tspan164-78",
    style: {
      fontSize: 16
    },
    y: 274.3197,
    x: 470.78055
  }, "MO")), /*#__PURE__*/React.createElement("text", {
    pointerEvents: "none",
    id: "text124-9-94",
    y: 275.55591,
    x: 381.77408,
    style: {
      fontStyle: "normal",
      fontWeight: "normal",
      fontSize: 40,
      lineHeight: 1.25,
      fontFamily: "sans-serif",
      letterSpacing: 0,
      wordSpacing: 0,
      fill: "#000000",
      fillOpacity: 1,
      stroke: "none",
      strokeLinejoin: "round"
    },
    xmlSpace: "preserve"
  }, /*#__PURE__*/React.createElement("tspan", {
    id: "tspan164-38",
    style: {
      fontSize: 16
    },
    y: 275.55591,
    x: 381.77408
  }, "KS")), /*#__PURE__*/React.createElement("text", {
    pointerEvents: "none",
    id: "text124-9-35",
    y: 210.03725,
    x: 361.9949,
    style: {
      fontStyle: "normal",
      fontWeight: "normal",
      fontSize: 40,
      lineHeight: 1.25,
      fontFamily: "sans-serif",
      letterSpacing: 0,
      wordSpacing: 0,
      fill: "#000000",
      fillOpacity: 1,
      stroke: "none",
      strokeLinejoin: "round"
    },
    xmlSpace: "preserve"
  }, /*#__PURE__*/React.createElement("tspan", {
    id: "tspan164-74",
    style: {
      fontSize: 16
    },
    y: 210.03725,
    x: 361.9949
  }, "OR")), /*#__PURE__*/React.createElement("text", {
    pointerEvents: "none",
    id: "text124-9-90",
    y: 192.73044,
    x: 452.23752,
    style: {
      fontStyle: "normal",
      fontWeight: "normal",
      fontSize: 40,
      lineHeight: 1.25,
      fontFamily: "sans-serif",
      letterSpacing: 0,
      wordSpacing: 0,
      fill: "#000000",
      fillOpacity: 1,
      stroke: "none",
      strokeLinejoin: "round"
    },
    xmlSpace: "preserve"
  }, /*#__PURE__*/React.createElement("tspan", {
    id: "tspan164-768",
    style: {
      fontSize: 16
    },
    y: 192.73044,
    x: 452.23752
  }, "IA")), /*#__PURE__*/React.createElement("text", {
    pointerEvents: "none",
    id: "text124-9-60",
    y: 227.34404,
    x: 528.88202,
    style: {
      fontStyle: "normal",
      fontWeight: "normal",
      fontSize: 40,
      lineHeight: 1.25,
      fontFamily: "sans-serif",
      letterSpacing: 0,
      wordSpacing: 0,
      fill: "#000000",
      fillOpacity: 1,
      stroke: "none",
      strokeLinejoin: "round"
    },
    xmlSpace: "preserve"
  }, /*#__PURE__*/React.createElement("tspan", {
    id: "tspan164-474",
    style: {
      fontSize: 16
    },
    y: 227.34404,
    x: 528.88202
  }, "IL")), /*#__PURE__*/React.createElement("text", {
    pointerEvents: "none",
    id: "text124-9-866",
    y: 261.95767,
    x: 271.75226,
    style: {
      fontStyle: "normal",
      fontWeight: "normal",
      fontSize: 40,
      lineHeight: 1.25,
      fontFamily: "sans-serif",
      letterSpacing: 0,
      wordSpacing: 0,
      fill: "#000000",
      fillOpacity: 1,
      stroke: "none",
      strokeLinejoin: "round"
    },
    xmlSpace: "preserve"
  }, /*#__PURE__*/React.createElement("tspan", {
    id: "tspan164-10",
    style: {
      fontSize: 16
    },
    y: 261.95767,
    x: 271.75226
  }, "CO")), /*#__PURE__*/React.createElement("text", {
    pointerEvents: "none",
    id: "text124-9-37",
    y: 245.88707,
    x: 175.32863,
    style: {
      fontStyle: "normal",
      fontWeight: "normal",
      fontSize: 40,
      lineHeight: 1.25,
      fontFamily: "sans-serif",
      letterSpacing: 0,
      wordSpacing: 0,
      fill: "#000000",
      fillOpacity: 1,
      stroke: "none",
      strokeLinejoin: "round"
    },
    xmlSpace: "preserve"
  }, /*#__PURE__*/React.createElement("tspan", {
    id: "tspan164-04",
    style: {
      fontSize: 16
    },
    y: 245.88707,
    x: 175.32863
  }, "UT")), /*#__PURE__*/React.createElement("text", {
    pointerEvents: "none",
    id: "text124-9-55",
    y: 337.36594,
    x: 159.25801,
    style: {
      fontStyle: "normal",
      fontWeight: "normal",
      fontSize: 40,
      lineHeight: 1.25,
      fontFamily: "sans-serif",
      letterSpacing: 0,
      wordSpacing: 0,
      fill: "#000000",
      fillOpacity: 1,
      stroke: "none",
      strokeLinejoin: "round"
    },
    xmlSpace: "preserve"
  }, /*#__PURE__*/React.createElement("tspan", {
    id: "tspan164-41",
    style: {
      fontSize: 16
    },
    y: 337.36594,
    x: 159.25801
  }, "AZ")), /*#__PURE__*/React.createElement("text", {
    pointerEvents: "none",
    id: "text124-9-32",
    y: 348.49173,
    x: 254.44545,
    style: {
      fontStyle: "normal",
      fontWeight: "normal",
      fontSize: 40,
      lineHeight: 1.25,
      fontFamily: "sans-serif",
      letterSpacing: 0,
      wordSpacing: 0,
      fill: "#000000",
      fillOpacity: 1,
      stroke: "none",
      strokeLinejoin: "round"
    },
    xmlSpace: "preserve"
  }, /*#__PURE__*/React.createElement("tspan", {
    id: "tspan164-01",
    style: {
      fontSize: 16
    },
    y: 348.49173,
    x: 254.44545
  }, "NM")), /*#__PURE__*/React.createElement("text", {
    pointerEvents: "none",
    id: "text124-9-945",
    y: 416.48276,
    x: 374.3569,
    style: {
      fontStyle: "normal",
      fontWeight: "normal",
      fontSize: 40,
      lineHeight: 1.25,
      fontFamily: "sans-serif",
      letterSpacing: 0,
      wordSpacing: 0,
      fill: "#000000",
      fillOpacity: 1,
      stroke: "none",
      strokeLinejoin: "round"
    },
    xmlSpace: "preserve"
  }, /*#__PURE__*/React.createElement("tspan", {
    id: "tspan164-29",
    style: {
      fontSize: 16
    },
    y: 416.48276,
    x: 374.3569
  }, "TX")), /*#__PURE__*/React.createElement("text", {
    pointerEvents: "none",
    id: "text124-9-863",
    y: 332.42111,
    x: 395.37228,
    style: {
      fontStyle: "normal",
      fontWeight: "normal",
      fontSize: 40,
      lineHeight: 1.25,
      fontFamily: "sans-serif",
      letterSpacing: 0,
      wordSpacing: 0,
      fill: "#000000",
      fillOpacity: 1,
      stroke: "none",
      strokeLinejoin: "round"
    },
    xmlSpace: "preserve"
  }, /*#__PURE__*/React.createElement("tspan", {
    id: "tspan164-477",
    style: {
      fontSize: 16
    },
    y: 332.42111,
    x: 395.37228
  }, "OK")), /*#__PURE__*/React.createElement("text", {
    pointerEvents: "none",
    id: "text124-9-83",
    y: 338.60214,
    x: 476.96152,
    style: {
      fontStyle: "normal",
      fontWeight: "normal",
      fontSize: 40,
      lineHeight: 1.25,
      fontFamily: "sans-serif",
      letterSpacing: 0,
      wordSpacing: 0,
      fill: "#000000",
      fillOpacity: 1,
      stroke: "none",
      strokeLinejoin: "round"
    },
    xmlSpace: "preserve"
  }, /*#__PURE__*/React.createElement("tspan", {
    id: "tspan164-00",
    style: {
      fontSize: 16
    },
    y: 338.60214,
    x: 476.96152
  }, "AR")), /*#__PURE__*/React.createElement("text", {
    pointerEvents: "none",
    id: "text124-9-549",
    y: 402.88455,
    x: 483.14255,
    style: {
      fontStyle: "normal",
      fontWeight: "normal",
      fontSize: 40,
      lineHeight: 1.25,
      fontFamily: "sans-serif",
      letterSpacing: 0,
      wordSpacing: 0,
      fill: "#000000",
      fillOpacity: 1,
      stroke: "none",
      strokeLinejoin: "round"
    },
    xmlSpace: "preserve"
  }, /*#__PURE__*/React.createElement("tspan", {
    id: "tspan164-69",
    style: {
      fontSize: 16
    },
    y: 402.88455,
    x: 483.14255
  }, "LA")), /*#__PURE__*/React.createElement("text", {
    pointerEvents: "none",
    id: "text124-9-77",
    y: 470.87561,
    x: 60.36195,
    style: {
      fontStyle: "normal",
      fontWeight: "normal",
      fontSize: 40,
      lineHeight: 1.25,
      fontFamily: "sans-serif",
      letterSpacing: 0,
      wordSpacing: 0,
      fill: "#000000",
      fillOpacity: 1,
      stroke: "none",
      strokeLinejoin: "round"
    },
    xmlSpace: "preserve"
  }, /*#__PURE__*/React.createElement("tspan", {
    id: "tspan164-25",
    style: {
      fontSize: 16
    },
    y: 470.87561,
    x: 60.36195
  }, "AK")), /*#__PURE__*/React.createElement("text", {
    pointerEvents: "none",
    id: "text124-9-39",
    y: 457.2774,
    x: 233.43004,
    style: {
      fontStyle: "normal",
      fontWeight: "normal",
      fontSize: 40,
      lineHeight: 1.25,
      fontFamily: "sans-serif",
      letterSpacing: 0,
      wordSpacing: 0,
      fill: "#000000",
      fillOpacity: 1,
      stroke: "none",
      strokeLinejoin: "round"
    },
    xmlSpace: "preserve"
  }, /*#__PURE__*/React.createElement("tspan", {
    id: "tspan164-14",
    style: {
      fontSize: 16
    },
    y: 457.2774,
    x: 233.43004
  }, "HI")), /*#__PURE__*/React.createElement("text", {
    pointerEvents: "none",
    id: "text124-9-12",
    y: 68.052818,
    x: 865.85687,
    style: {
      fontStyle: "normal",
      fontWeight: "normal",
      fontSize: 40,
      lineHeight: 1.25,
      fontFamily: "sans-serif",
      letterSpacing: 0,
      wordSpacing: 0,
      fill: "#000000",
      fillOpacity: 1,
      stroke: "none",
      strokeLinejoin: "round"
    },
    xmlSpace: "preserve"
  }, /*#__PURE__*/React.createElement("tspan", {
    id: "tspan164-46",
    style: {
      fontSize: 16
    },
    y: 68.052818,
    x: 865.85687
  }, "MA")), /*#__PURE__*/React.createElement("text", {
    pointerEvents: "none",
    id: "text124-9-467",
    y: 245.88707,
    x: 698.24152,
    style: {
      fontStyle: "normal",
      fontWeight: "normal",
      fontSize: 40,
      lineHeight: 1.25,
      fontFamily: "sans-serif",
      letterSpacing: 0,
      wordSpacing: 0,
      fill: "#000000",
      fillOpacity: 1,
      stroke: "none",
      strokeLinejoin: "round"
    },
    xmlSpace: "preserve"
  }, /*#__PURE__*/React.createElement("tspan", {
    id: "tspan164-97",
    style: {
      fontSize: 16
    },
    y: 245.88707,
    x: 698.24152
  }, "VA")), /*#__PURE__*/React.createElement("text", {
    pointerEvents: "none",
    id: "text124-9-79",
    y: 240.94228,
    x: 656.21069,
    style: {
      fontStyle: "normal",
      fontWeight: "normal",
      fontSize: 40,
      lineHeight: 1.25,
      fontFamily: "sans-serif",
      letterSpacing: 0,
      wordSpacing: 0,
      fill: "#000000",
      fillOpacity: 1,
      stroke: "none",
      strokeLinejoin: "round"
    },
    xmlSpace: "preserve"
  }, /*#__PURE__*/React.createElement("tspan", {
    id: "tspan164-92",
    style: {
      fontSize: 16
    },
    y: 240.94228,
    x: 656.21069
  }, "WV")), /*#__PURE__*/React.createElement("path", {
    id: "path5372",
    d: "M 859.23448,62.675864 799.70305,112.01088",
    style: {
      fill: "none",
      fillRule: "evenodd",
      stroke: "#cccccc",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path5374",
    d: "M 855.83488,97.289485 796.59699,128.70574",
    style: {
      fill: "none",
      fillRule: "evenodd",
      stroke: "#cccccc",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path5376",
    d: "m 841.30956,135.92076 -58.10143,-1.2362",
    style: {
      fill: "none",
      fillRule: "evenodd",
      stroke: "#cccccc",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path5378",
    d: "m 832.96521,170.53438 -65.58417,7.86768",
    style: {
      fill: "none",
      fillRule: "evenodd",
      stroke: "#cccccc",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path5380",
    d: "M 804.53259,209.4747 759.713,201.30895",
    style: {
      fill: "none",
      fillRule: "evenodd",
      stroke: "#cccccc",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path5382",
    d: "M 801.75114,247.48787 761.84843,215.57723",
    style: {
      fill: "none",
      fillRule: "evenodd",
      stroke: "#cccccc",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path5384",
    d: "M 794.95204,261.39513 743.01818,217.13027",
    style: {
      fill: "none",
      fillRule: "evenodd",
      stroke: "#cccccc",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path5386",
    d: "m 747.04926,35.479449 24.31136,20.428944",
    style: {
      fill: "none",
      fillRule: "evenodd",
      stroke: "#cccccc",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path5388",
    d: "m 726.66422,52.808895 28.71713,15.561761",
    style: {
      fill: "none",
      fillRule: "evenodd",
      stroke: "#cccccc",
      strokeWidth: "1.05246806px",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeOpacity: 1
    }
  }));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsAnnotated);
export default __webpack_public_path__ + "static/media/us-annotated.189aaf789ad0ed89be1eeb16e5ce1d38.svg";
export { ForwardRef as ReactComponent };